if ('scrollRestoration' in history) {
  // history.scrollRestoration = 'created-descending';
  history.scrollRestoration = 'auto';
  // history.scrollRestoration = 'manual';
}
window.addEventListener('load', function() {
  //  window.scrollTo(0, 0); //---
});

var PRODUCT_LIMIT = 36;
var seoHiddenProducts = 0;
var STANDARD_SIZE = 28;
let MONTHSARR = ["Jan","Feb","Mar","Apr","May","Jun","July","Aug","Sept","Oct","Nov","Dec"];

var only1TimeKinBanner = true;
var kinBannerIndex = 6;
var only1TimeBanner = true;
var bannerIndex = 12;
var only1TimeTSBanner = true;
var tsBannerIndex = 24;

if(document.body.clientWidth > 767){
  kinBannerIndex = 12;
  bannerIndex = 24;
  tsBannerIndex = 36;
}

function getUrlParameterBOOST(sParam) {
 var sPageURL = window.location.search.substring(1),
     sURLVariables = sPageURL.split('&'),
     sParameterName,
     i;

 for (i = 0; i < sURLVariables.length; i++) {
   sParameterName = sURLVariables[i].split('=');

   if (sParameterName[0] === sParam) {
     return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
   }
 }
 return false;
};

function resizeShopifyImage(url, size = '20x20') {
  if (!url) return '';
  return url.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/, `_${size}$1$3`);
}


function generateImageSrcset(imgSrc){
  let srcset = '';
  // srcset += `${imgSrc}&width=165 165w, `;
  // srcset += `${imgSrc}&width=360 360w, `;
  // srcset += `${imgSrc}&width=533 533w, `;
  // srcset += `${imgSrc}&width=720 720w, `;
  // srcset += `${imgSrc}&width=940 940w, `;
  // srcset += `${imgSrc}&width=1066 1066w, `;
  // srcset += `${imgSrc}&width=1200 1200w`;
  return srcset;
}


let SIZES = `(min-width: 1920px) 900px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)`;
let sizesArr = [ 165,360,533,720,940,1066 ];
var imgWidth = 400;
if(document.body.clientWidth <= 640){
  // imgWidth = document.body.clientWidth - 100;
  imgWidth = 400;
}
// function getResponsiveImageWidth() {
//   const vw = window.innerWidth;

//   if (vw <= 480) {
//     return 300; // mobile
//   }

//   if (vw <= 768) {
//     return 350; // tablet
//   }

//   return 400; // desktop / quickview
// }
// var imgWidth = getResponsiveImageWidth();

function swiperslider(event) {

  var touchStart = 0;


  $(document).on('dragstart', '.Grid__Cell .ProductItem__ImageWrapper', function (e) {
    touchStart = e.originalEvent.screenX;
  });

  $(document).on('dragend', '.Grid__Cell .ProductItem__ImageWrapper', function (e) {

    var $wrapperMain = $(this);
    var $container = $wrapperMain.find('.swiper-container0');
    var $wrapper = $wrapperMain.find('.swiper-wrapper0');

    var flkty = $container.data('flkty');
    if (flkty) return; 

    var images = $wrapperMain.attr('data-images');
    if (!images) return;

    var swiperImages = JSON.parse(images).image;
    var keys = Object.keys(swiperImages);

    if ($wrapper.find('.swiper-slide0').length < keys.length) {
      $.each(keys, function (index) {
        if (index > 0) {
          var img = swiperImages[keys[index]];
          $wrapper.append(`
            <div class="swiper-slide0">
              <img class="ProductItem__Image"
                src="${img}&width=${imgWidth}"
                srcset="${generateImageSrcset(img)}"
                sizes="${SIZES}">
            </div>
          `);
        }
      });
    }

    var flktyInstance = new Flickity($container[0], {
      cellSelector: '.swiper-slide0',
      wrapAround: true,
      pageDots: true,
      cellAlign: 'left',
      prevNextButtons: true,
      imagesLoaded: true,
      autoPlay: false
    });

    $container.data('flkty', flktyInstance);

    if (e?.originalEvent?.type === "dragend") {
      const endX = e.originalEvent.screenX;
      if ((touchStart - endX) > 5) {
        flktyInstance.next(true);
      }
    }

  });

}

// Run once
swiperslider();


function mobswiperslider(event) {
  var swiperInitialized = false;
  var touchStart = 0;
  $('.Grid__Cell .ProductItem__ImageWrapper').on('touchstart', function(e) {
    touchStart = e.originalEvent.touches[0].clientX;
  });
  $('.Grid__Cell .ProductItem__ImageWrapper').on('touchmove', function(e) {
    // console.log("(touchStart - e.originalEvent.touches[0].clientX)",(touchStart - e.originalEvent.touches[0].clientX));
    if((touchStart - e.originalEvent.touches[0].clientX) > 45){
      var $this = $(this);
      var swiperContainer = $this.find('.AspectRatio');
      if($(this).find('.swiper-wrapper0.flickity-enabled').length == 0){
        let arr = {};
        var images = $this.attr('data-images');
        var swiperImages = JSON.parse(images).image;
        var keys = Object.keys(swiperImages);
        // console.log("keys",keys,swiperImages);
        if ($this.find('.swiper-slide0').length < 3) {
          $.each(keys, function(index) {
            // Start from the second index (index 1)
            if (index > 0) {
              if(document.body.classList.contains("temp_image-3rd-at-1st") && index == 2){
                index = 0;
              }
              var key = keys[index];
              var imageUrl = swiperImages[key];
              if(index == 1){
                var $cellElems = $('<div class="swiper-slide0"><img class="ProductItem__Image" preload="true" fetchpriority="high" src="' + imageUrl + '&width='+imgWidth+'" srcset="'+generateImageSrcset(imageUrl)+'" sizes="'+SIZES+'"/></div>');
              }else{
                var $cellElems = $('<div class="swiper-slide0"><img class="ProductItem__Image" src="' + imageUrl + '&width='+imgWidth+'" srcset="'+generateImageSrcset(imageUrl)+'" sizes="'+SIZES+'"/></div>');
              }
              $this.find('.swiper-wrapper0').append($cellElems);
            }
          });
        }
        // console.log("arr",arr);
        var flkty1 = $(this).find('.swiper-wrapper0').flickity({
            wrapAround: true,
            pageDots: true,
            // initialIndex: 0,
            cellAlign: "left",
            prevNextButtons: true,
            imagesLoaded: true,
            // accessibility: true, //true by default
            autoPlay: false, // advance cells every 3 seconds
        });      
        // flkty1.flickity( 'next', true );
        setTimeout(() => {
          flkty1.flickity( 'next', true );

          dataLayer.push({
            event: "image_swiper",
            page_type: document.body.dataset.page,
            product_name: $(this).closest(".ProductItem__Wrapper").find(".ProductItem__Title").text().trim(),
            // cta_text: "",
            // link_path: location.href,
            user_type_event: loggedin,
            User_ID_event: user_id,
            PC1: pc1,
            PC2: pc2,
          });
        },200);
      }
      swiperInitialized = true;
    }
  });
}

console.log("boooooooooooooost");

function decodeHTML2(str) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}


var bannerHTML = null;
if(document.querySelector("[data-coll-list-banner]").innerHTML != undefined && document.querySelector("[data-coll-list-banner]").innerHTML != "" && document.querySelector("[data-coll-list-banner]").innerHTML != null){
  // bannerHTML = `<div data-view="${boostPFSThemeConfig.custom.mobile_row}" class="Grid__Cell Grid__Cell-banner 1/${boostPFSThemeConfig.custom.mobile_row}--phone 1/${boostPFSThemeConfig.custom.tablet_row}--tablet-and-up 1/${boostPFSThemeConfig.custom.desktop_row}--${buildClass()}">${document.querySelector("[data-coll-list-banner]").innerHTML}</div>`;
  bannerHTML = `<div data-view="${boostPFSThemeConfig.custom.mobile_row}" class="Grid__Cell Grid__Cell-banner 1/${boostPFSThemeConfig.custom.mobile_row}--phone 1/${boostPFSThemeConfig.custom.tablet_row}--tablet-and-up 1/${boostPFSThemeConfig.custom.desktop_row}--${buildClass()}">${decodeHTML2(document.querySelector("[data-coll-list-banner]").innerHTML)}</div>`;
}

var tsBannerHTML = null;
if(document.querySelector("[data-coll-list-ts-banner]").innerHTML != undefined && document.querySelector("[data-coll-list-ts-banner]").innerHTML != "" && document.querySelector("[data-coll-list-ts-banner]").innerHTML != null){
  tsBannerHTML = `<div data-view="${boostPFSThemeConfig.custom.mobile_row}" class="hide Grid__Cell Grid__Cell-banner Grid__Cell-banner-ts 1/${boostPFSThemeConfig.custom.mobile_row}--phone 1/${boostPFSThemeConfig.custom.tablet_row}--tablet-and-up 1/${boostPFSThemeConfig.custom.desktop_row}--${buildClass()}">${decodeHTML2(document.querySelector("[data-coll-list-ts-banner]").innerHTML)}</div>`;
}

var kinBannerHTML = null;
if(document.querySelector("[data-coll-list-kin-banner]").innerHTML != undefined && document.querySelector("[data-coll-list-kin-banner]").innerHTML != "" && document.querySelector("[data-coll-list-kin-banner]").innerHTML != null){
  kinBannerHTML = `<div data-view="${boostPFSThemeConfig.custom.mobile_row}" class="Grid__Cell Grid__Cell-banner Grid__Cell-banner-kin 1/${boostPFSThemeConfig.custom.mobile_row}--phone 1/${boostPFSThemeConfig.custom.tablet_row}--tablet-and-up 1/${boostPFSThemeConfig.custom.desktop_row}--${buildClass()}">${decodeHTML2(document.querySelector("[data-coll-list-kin-banner]").innerHTML)}</div>`;
}

var boostPFSTemplate = {
  'productGridItemHtml': '<div data-view="'+boostPFSThemeConfig.custom.mobile_row+'" class="Grid__Cell 1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone 1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass() +'" data-page="{{currentPage}}" data-index="{{productIndex}}">'+
                              '<div class="ProductItem boost-slider'+ buildClassHiz() +'">'+
                                  '<span class="product_sku_id hide">{{itemSku}}</span>'+
                                  '<div class="ProductItem__Wrapper">'+
                                      '{{itemImages}}' +											
                                      '{{itemInfo}}'+
                                      // '{{itemLabels}}'+
                                  '</div>'+
                                  // buildButtonSecond() +
                              '</div>'+
                          '</div>',

  // Pagination Template
  'previousActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
  'previousDisabledHtml': '',
  'nextActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
  'nextDisabledHtml': '',
  'pageItemHtml': '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
  'pageItemSelectedHtml': '<span class="Pagination__NavItem is-active">{{itemTitle}}</span>',
  'pageItemRemainHtml': '<span class="Pagination__NavItem">{{itemTitle}}</span>',
  'paginateHtml': ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
  'sortingHtml': '{{sortingItems}}',  
  'productGridBannerHtml': `${bannerHTML}`,
  'productGridTSBannerHtml': `${tsBannerHTML}`,
  'productGridKinBannerHtml':`${kinBannerHTML}`
};

var currentPage = 1;
if(getUrlParameterBOOST("page") != false){
  currentPage = Number(getUrlParameterBOOST("page"));
}

function prepareShopifyData(data) {
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
      for (var i = 0; i < data['variants'].length; i++) {
          if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
          }
      }
    return data;
}

// Build Product Grid Item
function buildCollItem(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
  
    var itemHtml = '';    
    if(index == bannerIndex && only1TimeBanner){
      // console.log("index",index);
      itemHtml = buildProductsItem(data, index);
      itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductItemUrl(data));
      itemHtml = itemHtml.replace(/{{currentPage}}/g, currentPage);
      itemHtml = itemHtml.replace(/{{productIndex}}/g, index != undefined ? index : 0);
      if(only1TimeBanner == true){
        var bannerHtml = buildProductsItem(data, -1);
        bannerHtml += itemHtml;
        itemHtml = bannerHtml;
        only1TimeBanner = false;
      }
    }else if(index == tsBannerIndex && only1TimeTSBanner){
      only1TimeTSBanner = false;
      // console.log("index",index);
      var bannerHtml = buildProductsItem(data, -2);
      // console.log("bannerHtml",bannerHtml);
      itemHtml = buildProductsItem(data, index);
      itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductItemUrl(data));
      itemHtml = itemHtml.replace(/{{currentPage}}/g, currentPage);
      itemHtml = itemHtml.replace(/{{productIndex}}/g, index != undefined ? index : 0);
      // console.log("itemHtml",itemHtml);
      bannerHtml += itemHtml;
      itemHtml = bannerHtml;
    }else if(index == kinBannerIndex && only1TimeKinBanner){
      only1TimeKinBanner = false;
      // console.log("index",index);
      var bannerHtml = buildProductsItem(data, -3);
      // console.log("bannerHtml",bannerHtml);
      itemHtml = buildProductsItem(data, index);
      itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductItemUrl(data));
      itemHtml = itemHtml.replace(/{{currentPage}}/g, currentPage);
      itemHtml = itemHtml.replace(/{{productIndex}}/g, index != undefined ? index : 0);
      // console.log("itemHtml",itemHtml);
      bannerHtml += itemHtml;
      itemHtml = bannerHtml;
    }else{
      itemHtml = buildProductsItem(data, index);
      itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductItemUrl(data));
      itemHtml = itemHtml.replace(/{{currentPage}}/g, currentPage);
      itemHtml = itemHtml.replace(/{{productIndex}}/g, index != undefined ? index : 0);
    }
    // itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
    return itemHtml;
};

function buildProductsItem(data, index) {
    var html = '';      
    // Get Template
    if(index == -1){
      var html = boostPFSTemplate.productGridBannerHtml;
    }else if(index == -2){
      var html = boostPFSTemplate.productGridTSBannerHtml;
    }else if(index == -3){
      var html = boostPFSTemplate.productGridKinBannerHtml;
    }else{
      var html = boostPFSTemplate.productGridItemHtml;
    }
    // // Add Images
    html = html.replace(/{{itemImages}}/g, buildImage(data, images));
    // // Add main attribute (Always put at the end of this function)
    html = html.replace(/{{itemInfo}}/g, buildInfo(data, index));
    return html;
}


function buildClass() {
    return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
}

function buildClassHiz() {
    return boostPFSThemeConfig.custom.use_horizontal ? ' ProductItem--horizontal' : '';
}

function buildProductItemUrl(data){
  return `/products/${data.handle}`;
}

function buildPrice(data) {
    var html = '';
    var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
    var classPriceHover = show_price_on_hover ? ' ProductItem__PriceList--showOnHover' : '';
    html += '<div class="ProductItem__PriceList' + classPriceHover + ' Heading">';
    const price = formatMoney(data.price_min * 100);
    const spacedMainPrice = price.replace(/(^[^\d]+)/, "$1 ");
    const Saleprice = formatMoney(data.compare_at_price_min * 100);
    const spacedSalePrice = Saleprice.replace(/(^[^\d]+)/, "$1 ");
    // console.log(spacedMainPrice,"spacedPrice",spacedSalePrice,"spacedSalePrice"); // ₹ 3,990

    if (onSale) {
        html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + spacedMainPrice + '</span> ';
        // let cmpPrice = formatMoney(data.compare_at_price_min*100).replace("₹","");
        let cmpPrice = spacedSalePrice;
        html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + cmpPrice + '</span>';
        let discount = data.compare_at_price_min - data.price_min;
        discount = (discount * 100) / data.compare_at_price_min;
        html += '<span class="ProductItem__Price-discount">' + Math.round(discount) + '%Off</span>';
    } else {
        if (priceVaries) {
            html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, spacedMainPrice) + '</span>';
        } else {
            html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + spacedMainPrice + '</span>';
        }
    }
    html += '</div>';
    // console.log("onSale",html);
    return html;
}

function buildImage(data, images) {
  var htmlImg = '';
  if (!images) images = [];
  if (images.length == 0){
      images.push({
          // src: boostPFSConfig.general.no_image_url,
          src: `http://www.bombayshirts.com/cdn/shop/t/556/assets/boost-pfs-no-image.gif?v=45510820439899768411743049518`,
          id: data.id,
          width: 480,
          height: 480
      });
  }
  var productimg = {
    "image" : data.images
  }

  let iplEdit = data.metafields.find(item => item.key === "ipl_edit")?.value;
  
  let occassion = data.metafields.filter((item) => {
    if(item.key == "occassion"){ return item.value; }
  });
  let colour = data.metafields.filter((item) => {
    if(item.key == "colour"){ return item.value; }
  });
  let pattern = data.tags.filter((item) => {
    if(item.includes("Pattern")){ return item; }
  });
  var dataImagesJson = JSON.stringify(productimg);
  var productData = {
    "id" :  data.id,	
    "title" : data.title,	
    "sku" : data.skus[0],	
    "product_type" : data.product_type,	
    "price_max": data.price_max,	
    "price_min": data.price_min,	
    "vendor" : data.vendor,
    "occassion": occassion.length > 0 ? JSON.parse(occassion[0].value)[0] : "NA",
    "colour": colour.length > 0 ? JSON.parse(colour[0].value)[0] : "NA",
    "pattern": pattern.length > 0 ?pattern[0].replace("Pattern-","").replace("Pattern_","") : "NA",
    // "metafields": data.metafields,
    "product_title": data.title,
    "variant_title": "NA"
  };
  if (images.length > 0) {

      // htmlImg += '<a data-product-id="'+data.id+'" data-product=\''+JSON.stringify(productData)+'\' href="{{itemUrl}}" data-images=\''+dataImagesJson+'\' class="ProductItem__ImageWrapper';
      htmlImg += '<a data-product-id="'+data.id+'" data-product=\''+JSON.stringify(productData)+'\' href="{{itemUrl}}" data-images=\''+dataImagesJson+'\' class="ProductItem__ImageWrapper';
      var use_natural_size = false;
      var has_alternate_image = false;          
      htmlImg += '">';   

      // let justIn = "";
      // console.log("data",data);
      let justIn = data.metafields.filter(n => { return n.key == "just_in" && n.value == "true" });
      if(justIn.length > 0){
        htmlImg += `<span class="ProductItem__Label Heading Text--subdued ProductItem__Label-just_in">Just In</span>`;
      }else{
        let dailyDropsObj = document.querySelector(`[data-daily-drops]`) && document.querySelector(`[data-daily-drops]`).dataset.dailyDrops != undefined ? JSON.parse(document.querySelector(`[data-daily-drops]`).dataset.dailyDrops) : null;
        if(dailyDropsObj){
          let checkFor1time = 0;
          // console.log("dailyDropsObj",dailyDropsObj);
          const currentTimestamp = new Date().setHours(0, 0, 0, 0);
          const filtered = dailyDropsObj.filter(item => {
            const itemTimestamp = new Date(item.date).getTime();
            // console.log("item",item);
            if(itemTimestamp < currentTimestamp){
              // console.log("item ifffff");
              return item;
            }else{
              // console.log("item elseeeeeeee");
              let diff = itemTimestamp - currentTimestamp;
              let currH = new Date().getHours();
              if(diff < 86400000 && currH > 18){
                return item;
              }
            }
            // return itemTimestamp > currentTimestamp; //diff < 86400000
          });
          // console.log("filtered",filtered);
          filtered.forEach(dDrop => {
            if(checkFor1time == 0){
              // console.log("dDrop",dDrop);
              let proIds = dDrop.products.filter(item => {
                let proId = item.replace("gid://shopify/Product/","");
                return proId == data.id;
              });
              if(proIds.length > 0){
                htmlImg += `<span class="ProductItem__Label Heading Text--subdued ProductItem__Label-just_in">${new Date(dDrop.date).getDate()} ${MONTHSARR[new Date(dDrop.date).getMonth()]}</span>`;
                checkFor1time++;
              }
            }
          });
        }
      }
      let desireIndex = 0;
      if(document.body.classList.contains("temp_image-3rd-at-1st")){
        desireIndex = 2;
      }

      let itemURL = `${location.origin}${buildProductItemUrl(data)}`;
      let wishlist = `<button role="button" title="Add to Wishlist" aria-label="Add to Wishlist" data-with-epi="true" class="hide swym-button swym-add-to-wishlist-view-product product_${data.id}" data-swaction="addToWishlist" data-product-id="${data.id}" data-variant-id="${data.variants[0].id}" data-product-url="${itemURL}"></button>`;
      htmlImg += wishlist;
      var max_width = images[desireIndex].width;
      if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
      var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
      htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
      var aspect_ratio = images[desireIndex].width / images[desireIndex].height;
      htmlImg += '--aspect-ratio: ' + aspect_ratio + '">';
      let srcset = '';
      // if(images[desireIndex].width >= 165){
      //   // console.log(images[desireIndex].width,"165");
      //   srcset += `${images[desireIndex]['src']}&width=165 165w, `;
      // }
      // if(images[desireIndex].width >= 360){
      //   // console.log(images[desireIndex].width,"360");
      //   srcset += `${images[desireIndex]['src']}&width=360 360w, `;
      // }
      // if(images[desireIndex].width >= 533){
      //   // console.log(images[desireIndex].width,"533");
      //   srcset += `${images[desireIndex]['src']}&width=533 533w, `;
      // }
      // if(images[desireIndex].width >= 720){
      //   // console.log(images[desireIndex].width,"720");
      //   srcset += `${images[desireIndex]['src']}&width=720 720w, `;
      // }
      // if(images[desireIndex].width >= 940){
      //   // console.log(images[desireIndex].width,"940");
      //   srcset += `${images[desireIndex]['src']}&width=940 940w, `;
      // }
      // if(images[desireIndex].width >= 1066){
      //   // console.log(images[desireIndex].width,"1066");
      //   srcset += `${images[desireIndex]['src']}&width=1066 1066w, `;
      // }
      // srcset += `${images[desireIndex]['src']}&width=${images[desireIndex].width} ${images[desireIndex].width}w`;


      var imgEle2 = '';
      let srcset2 = '';
      if(images[1] != undefined){
      // console.log("images[1]",images[1].src);
        // if(images[1].width >= 165){
        //   srcset2 += `${images[1]['src']}&width=165 165w, `;
        // }
        // if(images[1].width >= 360){
        //   srcset2 += `${images[1]['src']}&width=360 360w, `;
        // }
        // if(images[1].width >= 533){
        //   srcset2 += `${images[1]['src']}&width=533 533w, `;
        // }
        // if(images[1].width >= 720){
        //   srcset2 += `${images[1]['src']}&width=720 720w, `;
        // }
        // if(images[1].width >= 940){
        //   srcset2 += `${images[1]['src']}&width=940 940w, `;
        // }
        // if(images[1].width >= 1066){
        //   srcset2 += `${images[1]['src']}&width=1066 1066w, `;
        // }
        // srcset2 += `${images[1]['src']}&width=${images[1].width} ${images[1].width}w`;
        imgEle2 = '<div class="swiper-slide0"><img class="filter-img ProductItem__Image" src="'+ images[1]['src'] +'&width='+imgWidth+'" srcset="'+srcset2+'" sizes="'+SIZES+'" preload="true" fetchpriority="high" alt="' + data.title + '" data-image-id="' + images[1].id + '"></div>';
      }
      // srcset = srcset.slice(0, -2);

      // console.log("images.length",images.length);
      // let dotsHtml = '';
      // images.forEach((img,inx) => {
      //   if(inx == 0){
      //     dotsHtml = `<li class="active"></li>`;
      //   }else{
      //     dotsHtml += `<li></li>`;
      //   }
      // });

    
      dotsHtml = `<li></li><li></li><li></li>`;

      var metaReview = '';
      data.metafields.forEach(metaF => {
        if(metaF.key == "badge" && metaF.namespace == "judgeme"){
          metaReview = metaF.value;
        }
      });
      // if(metaReview){
        let reviewHtml = 
          `<div class="plp-custom-review-wrapper">
            <div class='jdgm-widget jdgm-preview-badge' data-id='${data.id}' data-auto-install='false'>
              ${metaReview}
            </div>
            <div class="review-star-wrapper">
              <span class="review-star-value">
              </span>
            </div>
          </div>`;
          // console.log(reviewHtml.getAttribute("data-average-rating"),"reviewHtml");
      // }

      var reviewInterval;

    function startReviewCheck() {
        if (reviewInterval) clearInterval(reviewInterval);
        reviewInterval = setInterval(customReview, 200);
    }

    function customReview() {
        let wrappers = document.querySelectorAll(".plp-custom-review-wrapper");
        if (!wrappers.length) return;

        let processedCount = 0;

        wrappers.forEach(wrapper => {
            const widget = wrapper.querySelector(".jdgm-widget.jdgm-preview-badge");
            const badge = wrapper.querySelector(".jdgm-prev-badge");
            const ratingSpan = wrapper.querySelector(".review-star-value");

            // If widget exists but is EMPTY → hide wrapper
            if (widget && widget.innerHTML.trim().length === 0) {
                wrapper.classList.add("hide");
                processedCount++;
                return;
            }

            // No widget OR no badge OR no span → skip until available
            if (!widget || !badge || !ratingSpan) return;

            const rating = parseFloat(badge.dataset.averageRating || 0);

            if (rating > 0) {
                const displayRating = (Math.round(rating * 10) / 10).toFixed(1);

                ratingSpan.innerHTML = `
                    <svg width="12" height="12" viewBox="0 0 12 12">
                        <path d="M5.99986 0L7.99967 4.49769L12 4.99747L8.99957 7.49617L9.99947 11.9939L5.99986 9.49502L1.99995 11.9939L2.99993 7.49617L0 4.99747L3.9999 4.49769L5.99986 0Z" fill="#F39C12"></path>
                    </svg>
                    ${displayRating}
                `;
            } else {
                wrapper.classList.add("hide");
            }

            processedCount++;
        });

        // Stop only after all processed
        if (processedCount === wrappers.length) {
            clearInterval(reviewInterval);
        }
    }

    // Run on first load
    startReviewCheck();

    // Run again on layout change
    document.querySelectorAll(".CollectionToolbar__LayoutType").forEach(btn => {
        btn.addEventListener("click", () => {
            setTimeout(() => startReviewCheck(), 300);
        });
    });

      
      htmlImg += '<div class="swiper-container0"><div class="swiper-wrapper0"><div class="swiper-slide0"><img class="filter-img ProductItem__Image" src="'+ images[desireIndex]['src'] +'&width='+imgWidth+'" fetchpriority="high" srcset="'+srcset+'" sizes="'+SIZES+'" alt="' + data.title + '" data-image-id="' + images[0].id + '"></div></div></div><div class="custom-flickity-arrow-container"><button class="coll-grid-flickity-prev-next-button previous" type="button" aria-label="previous"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99342 5.91338C7.96953 5.78021 7.89396 5.6567 7.77765 5.55999L1.40535 0.227137C1.26385 0.0924746 1.05938 0.0106381 0.84047 0.000966632C0.62137 -0.00870526 0.407087 0.0545312 0.247998 0.175953C0.0889034 0.297222 -0.000735283 0.465957 4.29153e-06 0.64212C0.000745296 0.818444 0.0918674 0.986585 0.252071 1.10711L6.10188 6L0.252071 10.8929C0.0918674 11.0134 0.000743866 11.1816 4.29153e-06 11.3579C-0.000736237 11.5341 0.0889034 11.7028 0.247998 11.824C0.407092 11.9455 0.621375 12.0087 0.84047 11.999C1.05939 11.9894 1.26385 11.9075 1.40535 11.7729L7.77765 6.44001C7.94527 6.29984 8.0249 6.10606 7.99342 5.91338Z" fill="white"/></svg></button><button class="coll-grid-flickity-prev-next-button next" type="button" aria-label="next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99342 5.91338C7.96953 5.78021 7.89396 5.6567 7.77765 5.55999L1.40535 0.227137C1.26385 0.0924746 1.05938 0.0106381 0.84047 0.000966632C0.62137 -0.00870526 0.407087 0.0545312 0.247998 0.175953C0.0889034 0.297222 -0.000735283 0.465957 4.29153e-06 0.64212C0.000745296 0.818444 0.0918674 0.986585 0.252071 1.10711L6.10188 6L0.252071 10.8929C0.0918674 11.0134 0.000743866 11.1816 4.29153e-06 11.3579C-0.000736237 11.5341 0.0889034 11.7028 0.247998 11.824C0.407092 11.9455 0.621375 12.0087 0.84047 11.999C1.05939 11.9894 1.26385 11.9075 1.40535 11.7729L7.77765 6.44001C7.94527 6.29984 8.0249 6.10606 7.99342 5.91338Z" fill="white"/></svg></button></div><div class="main-collection-review-star">'+reviewHtml+'</div><ul class="coll-dots-main">'+dotsHtml+'</ul>';

      // htmlImg += '<div class="swiper-container0"><div class="swiper-wrapper0"><div class="swiper-slide0"><img class="filter-img ProductItem__Image" src="'+ images[desireIndex]['src'] +'&width='+imgWidth+'" srcset="'+srcset+'" sizes="'+SIZES+'" alt="' + data.title + '" data-image-id="' + images[0].id + '"></div>  '+imgEle2+'  </div></div><div class="custom-flickity-arrow-container"><button class="coll-grid-flickity-prev-next-button previous" type="button" aria-label="previous"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99342 5.91338C7.96953 5.78021 7.89396 5.6567 7.77765 5.55999L1.40535 0.227137C1.26385 0.0924746 1.05938 0.0106381 0.84047 0.000966632C0.62137 -0.00870526 0.407087 0.0545312 0.247998 0.175953C0.0889034 0.297222 -0.000735283 0.465957 4.29153e-06 0.64212C0.000745296 0.818444 0.0918674 0.986585 0.252071 1.10711L6.10188 6L0.252071 10.8929C0.0918674 11.0134 0.000743866 11.1816 4.29153e-06 11.3579C-0.000736237 11.5341 0.0889034 11.7028 0.247998 11.824C0.407092 11.9455 0.621375 12.0087 0.84047 11.999C1.05939 11.9894 1.26385 11.9075 1.40535 11.7729L7.77765 6.44001C7.94527 6.29984 8.0249 6.10606 7.99342 5.91338Z" fill="white"/></svg></button><button class="coll-grid-flickity-prev-next-button next" type="button" aria-label="next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99342 5.91338C7.96953 5.78021 7.89396 5.6567 7.77765 5.55999L1.40535 0.227137C1.26385 0.0924746 1.05938 0.0106381 0.84047 0.000966632C0.62137 -0.00870526 0.407087 0.0545312 0.247998 0.175953C0.0889034 0.297222 -0.000735283 0.465957 4.29153e-06 0.64212C0.000745296 0.818444 0.0918674 0.986585 0.252071 1.10711L6.10188 6L0.252071 10.8929C0.0918674 11.0134 0.000743866 11.1816 4.29153e-06 11.3579C-0.000736237 11.5341 0.0889034 11.7028 0.247998 11.824C0.407092 11.9455 0.621375 12.0087 0.84047 11.999C1.05939 11.9894 1.26385 11.9075 1.40535 11.7729L7.77765 6.44001C7.94527 6.29984 8.0249 6.10606 7.99342 5.91338Z" fill="white"/></svg></button></div><div class="main-collection-review-star">'+reviewHtml+'</div><ul class="coll-dots-main">'+dotsHtml+'</ul>';

      // htmlImg += '<div class="swiper-container0"><div class="swiper-wrapper0"><div class="swiper-slide0"><img class="filter-img ProductItem__Image" src="'+ images[desireIndex]['src'] +'&width='+imgWidth+'" srcset="'+srcset+'" sizes="'+SIZES+'" alt="' + data.title + '" data-image-id="' + images[0].id + '"></div>  '+imgEle2+'</div></div><ul class="coll-dots-main">'+dotsHtml+'</ul>';
      htmlImg += '</div>';
      htmlImg += '</a>';
  }
  return htmlImg;
}

function buildInfo(data, indx, variant) {
  var html = '';
  if (boostPFSThemeConfig.custom.show_product_info) {
    var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? ' ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
    html += '<div class="ProductItem__Info' + infoClass + '">';
    var tags = data.tags;
    var product_labels = '';
    if (boostPFSThemeConfig.custom.show_labels) {
      product_labels = '';
      
      let allowForBadge = false;
      var customisable_product_type = '';
      data.metafields.forEach(metaF => {
        if(metaF.key == "product_type"){
          customisable_product_type = metaF.value;
        }
      });
      // console.log("data",data);
      if(data.product_type == "Shirt" && tags.includes("Product Type_Customisable") || tags.includes("Product Type-Pre-Designed")){
      // if(data.product_type == "Shirt" && customisable_product_type.includes("Customisable") || tags.includes("Product Type-Pre-Designed")){
        // console.log(customisable_product_type,"product_typeMeta");
        allowForBadge = true;
      } else if(customisable_product_type.includes("Semi-Stitched") || tags.includes("Product Type-Semi-Stitched")){
        allowForBadge = true;
      } else if(tags.includes("Product Type_Semi-Stitched") || tags.includes("Product Type-Semi-Stitched")){
        allowForBadge = true;
      }
      // else if(data.product_type == "Neapolitan Dress Pants" && tags.includes("Product Type_Semi-Stitched")){
      //   allowForBadge = true;
      // }else if(data.product_type == "Dress Pants" && tags.includes("Product Type_Semi-Stitched")){
      //   allowForBadge = true;
      // }else if(data.product_type == "Chinos" && tags.includes("Product Type_Semi-Stitched")){
      //   allowForBadge = true;
      // }else if(data.product_type == "Jeans" && tags.includes("Product Type_Semi-Stitched")){
      //   allowForBadge = true;
      // }else if(data.product_type == "Jackets" && tags.includes("Product Type_Semi-Stitched")){
      //   allowForBadge = true;
      // }else if(data.product_type == "Casual Chinos" || data.product_type == "Stretch Denim" || data.product_type == "Rigid Denim"){
      //   allowForBadge = true;
      // }
      if(allowForBadge){
        // product_labels += '<span class="ProductItem__Label ProductItem__Label-customisable Heading Text--subdued ' + customisable_product_type + '">' + customisable_product_type + '</span>';
        // static Customisable ---
        product_labels += '<span class="ProductItem__Label ProductItem__Label-customisable Heading Text--subdued Customisable">Customisable</span>';
        
      }
      var fCustNudge = '';
      data.metafields.forEach(metaF => {
        // console.log(metaF.key,"metaF.key");
        
        if(metaF.key == "Nudge"){
          fCustNudge = metaF.value;
        }
      });
      // console.log(fCustNudge,"fCustNudge");

      // ==== New tag using Metafield of the products start ==== //
      let MetaValueNudge = data.metafields.filter(item => item.key.includes("nudge")).map(item => item.value);
      // console.log(MetaValueNudge,"MetaValueNudgedata");
      if(MetaValueNudge != ""){
        product_labels += '<span meta-nudge class="ProductItem__Label ProductItem__Label-tag_based Heading Text--subdued '+MetaValueNudge+'">' + MetaValueNudge + '</span>';
      } else {
        for (var k = 0; k < tags.length; k++) {
          var tag = tags[k];
          if (tag.indexOf('__label') != -1) {
            const tagLabelvalue = tag.split('__label:')[1];
            if(tagLabelvalue != ''){
              if(tagLabelvalue != "null"){
              product_labels += '<span __label tag-nudge class="ProductItem__Label ProductItem__Label-tag_based Heading Text--subdued ' + tagLabelvalue + '">' + tagLabelvalue + '</span>';
              }
            }
            break;
          } else if (tag.indexOf('Nudge_') != -1) {
            const nudgeValuetag = tag.split('Nudge_')[1];
            if(nudgeValuetag != ''){
              if(nudgeValuetag != "null"){
              product_labels += '<span Nudge_ tag-nudge class="ProductItem__Label ProductItem__Label-tag_based Heading Text--subdued ' + nudgeValuetag + '">' + nudgeValuetag + '</span>';
              }
            }
            break;
          } 
          // else if (tag.indexOf('Nudge-') != -1) {
          //   product_labels += '<span tag-nudge class="ProductItem__Label ProductItem__Label-tag_based Heading Text--subdued">' + tag.split('Nudge-')[1] + '</span>';
          //   break;
          // }
        } 
      }
      // ==== New tag using Metafield of the products end ==== //

      // ==== New tag using Tag of the products start ==== //
      // for (var k = 0; k < tags.length; k++) {
      //   var tag = tags[k];
      //   if (tag.indexOf('__label') != -1) {
      //   product_labels += '<span class="ProductItem__Label ProductItem__Label-tag_based Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
      //   break;
      //   }
      // }
      // ==== New tag using Tag of the products end ==== //

      let myManu = data.metafields.filter(n => { return n.key == "month_year_of_manufacturing" && n.value == "September, 2025" });
      if(myManu.length > 0){
        product_labels += '<span class="ProductItem__Label ProductItem__Label-customisable ProductItem__Label-gst Heading Text--subdued">GST Benefit</span>';
      }
      if (product_labels != '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }
    }
    
    html += '<h2 class="ProductItem__Title Heading">';
    html += '<a aria-label="Product URL" href="{{itemUrl}}">' + data.title + '</a>';
    html += '</h2>';
    html += buildPrice(data);
    let disPrice = data.price_min * 10 / 100;
    let memPrice = data.price_min - disPrice;
    let memURL = `/products/bsc-membership`;
    let memShow = "";
    if(data.compare_at_price_min != null && data.compare_at_price_min != 0){
      memShow = " hide";
    }else if(!document.body.classList.contains("is-member")){
      memShow = " hide";
    }
    // <a href="${memURL}">Member Price ${formatMoney(memPrice*100)}</a>
   let membershipHTML = `<div data-sale="${data.compare_at_price_min}" class="grid-menbership${memShow}${data.product_type == 'Gift Card' ? " hide" : ""}">
    Member Price ${formatMoney(memPrice*100)}
    </div>`;
    html += membershipHTML;

    let designType = 'SEMI_STITCHED';
    if(data.product_type == 'Jackets' && data.tags.includes('Product Type_Hemming')){
      designType = 'HEMMING';
    }else if(data.product_type == 'Stretch Denim' || data.product_type == 'Mid Rise Stretch Jeans' || data.product_type == 'Mid Rise Rigid Jeans' || data.product_type == 'Rigid Denim' || data.product_type == 'Casual Chinos' || data.product_type == 'Relaxed Linen Pants'){
      designType = 'HEMMING';
    }
    
    if (data.handle == "bsc-wrinkle-free-bamboo-blend-shirt-pink") {
      // console.log(data,"datatata");
    }

    let itemURL = `${location.origin}${buildProductItemUrl(data)}`;
    let quickViewHTML = `<div class="custom-main-wishlist-atc-wrapper pro-quickview-btn-wrap${data.product_type == 'Gift Card' ? " hide" : ""}">
      <div class="collection-grid custom-pro-wishlits-btn-wrap">
        <button role="button" title="Add to Wishlist" aria-label="Add to Wishlist" data-with-epi="true" class="new-coll-wishlist swym-add-to-wishlist-view-product product_${data.id}" data-swaction="addToWishlist" data-product-id="${data.id}" data-variant-id="${data.variants[0].id}" data-product-url="${itemURL}">
        <span id="swym-icon-unfilled" class="wishlist-content"><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 18C9.71527 18 9.44077 17.8957 9.22684 17.7061C8.41888 16.9914 7.63992 16.3198 6.95267 15.7274L6.94916 15.7243C4.93423 13.9873 3.19427 12.4873 1.98364 11.0096C0.630341 9.35765 0 7.79138 0 6.08032C0 4.41788 0.563507 2.88418 1.58661 1.76153C2.62192 0.625613 4.04251 0 5.58716 0C6.74164 0 7.79892 0.369224 8.72955 1.09733C9.19922 1.46486 9.62494 1.91466 10 2.43932C10.3752 1.91466 10.8008 1.46486 11.2706 1.09733C12.2012 0.369224 13.2585 0 14.413 0C15.9575 0 17.3782 0.625613 18.4135 1.76153C19.4366 2.88418 20 4.41788 20 6.08032C20 7.79138 19.3698 9.35765 18.0165 11.0094C16.8059 12.4873 15.0661 13.9872 13.0515 15.724C12.363 16.3173 11.5828 16.99 10.773 17.7064C10.5592 17.8957 10.2846 18 10 18ZM5.58716 1.18516C4.37363 1.18516 3.25882 1.67509 2.44781 2.56481C1.62476 3.46796 1.17142 4.71641 1.17142 6.08032C1.17142 7.5194 1.70013 8.80644 2.88559 10.2534C4.03137 11.652 5.73563 13.1212 7.70889 14.8224L7.71255 14.8255C8.4024 15.4202 9.18442 16.0944 9.99832 16.8144C10.8171 16.0931 11.6003 15.4177 12.2916 14.8221C14.2647 13.1209 15.9688 11.652 17.1146 10.2534C18.2999 8.80644 18.8286 7.5194 18.8286 6.08032C18.8286 4.71641 18.3752 3.46796 17.5522 2.56481C16.7413 1.67509 15.6264 1.18516 14.413 1.18516C13.524 1.18516 12.7078 1.47103 11.9872 2.03475C11.3449 2.53734 10.8975 3.17268 10.6352 3.61723C10.5003 3.84583 10.2629 3.98228 10 3.98228C9.73709 3.98228 9.49966 3.84583 9.36478 3.61723C9.10263 3.17268 8.65524 2.53734 8.01285 2.03475C7.29218 1.47103 6.47598 1.18516 5.58716 1.18516Z" fill="#5B5B5B"/></svg></span><span id="swym-icon-filled" class="wishlist-content"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 18" height="18" width="21"><g clip-path="url(#clip0_593_4)"><path stroke-linejoin="round" stroke-linecap="round" stroke="#E23744" fill="#E23744" d="M20 5.5C20 11.7444 10.5004 17 10.5004 17C10.5004 17 1 11.6667 1 5.51265C1 3 3.11111 1 5.75 1C8.38889 1 10.5 4 10.5 4C10.5 4 12.6111 1 15.25 1C17.8889 1 20 3 20 5.5Z" clip-rule="evenodd" fill-rule="evenodd"/></g><defs><clipPath id="clip0_593_4"><rect fill="white" height="18" width="21"/></clipPath></defs></svg></path></svg></span>
        </button>
      </div>
    <button aria-label="Add to cart" class="" data-handle="${data.handle}" data-type="${data.product_type}" data-template="${data.template_suffix}" data-designtype="${designType}" data-title="${data.title}" data-pro-quickview-open-btn>
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.7592 12.118H10.5772V9.89527C10.5772 9.65598 10.3872 9.4624 10.1523 9.4624C9.91738 9.4624 9.72735 9.65598 9.72735 9.89527V12.118H7.54541C7.31051 12.118 7.12048 12.3116 7.12048 12.5509C7.12048 12.7902 7.31051 12.9837 7.54541 12.9837H9.72735V15.2064C9.72735 15.4457 9.91738 15.6393 10.1523 15.6393C10.3872 15.6393 10.5772 15.4457 10.5772 15.2064V12.9837H12.7592C12.9941 12.9837 13.1841 12.7902 13.1841 12.5509C13.1841 12.3116 12.9941 12.118 12.7592 12.118Z" fill="#5B5B5B" stroke="#5B5B5B" stroke-width="0.3"/>
                  <path d="M20.0923 15.8491L18.6872 7.95251C18.378 6.21427 16.8953 4.95288 15.1616 4.95288H14.9939C14.943 3.70448 14.4617 2.52637 13.5939 1.6176C12.6668 0.671514 11.4435 0.149902 10.1488 0.149902C7.53495 0.149902 5.40222 2.2863 5.29395 4.95297H5.13842C3.4047 4.95297 1.92195 6.21436 1.61285 7.9526L0.20769 15.8491C0.0180853 16.9169 0.300664 18.0067 0.983698 18.8394C1.66631 19.6722 2.66847 20.1499 3.73368 20.1499H16.5663C17.6315 20.1499 18.6336 19.6722 19.3162 18.8394C19.9994 18.0067 20.2819 16.9169 20.0923 15.8491ZM10.1487 1.01556C11.216 1.01556 12.2256 1.4467 12.9883 2.22544C13.6973 2.96781 14.0937 3.93122 14.144 4.95288H6.15401C6.2627 2.76532 8.00458 1.01556 10.1487 1.01556ZM18.6644 18.2848C18.1436 18.9198 17.3788 19.2842 16.5663 19.2842H3.73368C2.92113 19.2842 2.15634 18.9198 1.63554 18.2848C1.11475 17.649 0.899393 16.818 1.04421 16.003L2.44929 8.10644C2.68495 6.78081 3.81578 5.81862 5.13833 5.81862H5.28358V7.26182C5.28358 7.50111 5.47361 7.69469 5.70851 7.69469C5.94341 7.69469 6.13344 7.50111 6.13344 7.26182V5.81862H14.164V7.26182C14.164 7.50111 14.354 7.69469 14.5889 7.69469C14.8238 7.69469 15.0138 7.50111 15.0138 7.26182V5.81862H15.1615C16.4841 5.81862 17.6148 6.78073 17.8506 8.10644L19.2557 16.003C19.4006 16.8179 19.1851 17.649 18.6644 18.2848Z" fill="#5B5B5B" stroke="#5B5B5B" stroke-width="0.3"/>
      </button>
    </div>`;
      html += quickViewHTML;

 let MetaValue = data.metafields.filter(item => item.key.includes("product_variants")).map(item => item.value);

    if (MetaValue.length > 0) {

      let Metaparsed = JSON.parse(MetaValue[0]);
      let MetaIds = Metaparsed.map(id =>
        id.replace("gid://shopify/Product/", "")
      );

      const gidIds = MetaIds.map(id => `gid://shopify/Product/${id}`);

      const query = `
        query getProductMetafields($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              productType
              onlineStoreUrl
              availableForSale

              metafield(namespace: "custom", key: "product_type") {
                value
              }

              images(first: 20) {
                edges {
                  node {
                    url
                  }
                }
              }
            }
          }
        }
      `;

      async function fetchMetaData() {
        try {
          const response = await fetch(`https://${shopURL}/api/2025-01/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({
              query,
              variables: { ids: gidIds }
            })
          });

          const result = await response.json();
          // Remove null nodes (deleted / invalid products)
          const products = (result.data?.nodes || []).filter(p => p !== null);

          if (!products.length) {
            console.warn("No valid products returned from metafields");
            return;
          }

          // safe access
          const avaHandle = products[0]?.handle;
          // console.log(avaHandle, "avaHandle");

          // MAIN PRODUCT
          const mainProductId = data.id;
          const mainEdges = data.images?.edges || [];
          const mainLastImage = mainEdges.length
            ? mainEdges[mainEdges.length - 1].node.url
            : "";

          const mergedImagesByProduct = {};
          mergedImagesByProduct[mainProductId] = [];

          // push main product image once
          if (mainLastImage) {
            mergedImagesByProduct[mainProductId].push({
              img: mainLastImage,
              url: `/products/${data.handle}`
            });
          }

          // add only available product images
          console.log("productsss",products);
          
          products.forEach(product => {
            if (!product.availableForSale) return;

              const edges = product.images?.edges || [];
              const productTypeMeta = product.metafield?.value;
              const useFirstImage = (productTypeMeta === "Customisable" && product.productType === "Shirt") || productTypeMeta === "ACCESSORIES";

              const selectedImage = edges.length ? (useFirstImage ? edges[0].node.url : edges[edges.length - 1].node.url) : "";

              if (selectedImage) {
                mergedImagesByProduct[mainProductId].push({
                  img: selectedImage,
                  url: product.onlineStoreUrl || `/products/${product.handle}`
                });
              }
          });

          Object.keys(mergedImagesByProduct).forEach(productId => {
            const container = document.querySelector(
              `.grid-product[data-product-id="${productId}"] .custom-pro-variant-color-swatches`
            );

            if (!container) return;

            const images = mergedImagesByProduct[productId];
            const maxVisible = 6;
            const visibleImages = images.slice(0, maxVisible);
            const remaining = images.length - maxVisible;

            let html = visibleImages.map(item => `
                  <span boostgrid1 class="new-color-varient desktop-swatches">
                    <div class="inner_metacolor">
                      <div class="var-outer">
                        <img 
                          class="metafieldProdImage" 
                          src="${resizeShopifyImage(item.img, '20x20')}"
                          alt="product variant image" 
                          width="12" 
                          height="12" 
                        />
                      </div>
                    </div>
                  </span>
                `).join('');

            if (remaining > 0) {
              html += `
              <div boostgrid2 class="new-color-varient desktop-swatches">
                <div class="inner_metacolor">
                  <div class="var-outer">
                    <span>+${remaining}</span>
                  </div>
                </div>
              </div>
              `;
            }

            container.innerHTML = html;

          });

        } catch (error) {
          console.error("Error fetching Meta data:", error);
        }
      }

      fetchMetaData();
    }
    
    const mainProdURL = "https://www.bombayshirts.com/products/"+data.handle;
    quickViewHTML = `<div class="grid-product" data-product-id="${data.id}"><a class="boost-main-product-coll-url" aria-label="main product URL" href="`+mainProdURL+`"><div class='custom-pro-variant-color-swatches'></div></a></div>`
    // let metaColorHTML = `<div class="custom-pro-variant-color-swatches"></div>`;
    html += quickViewHTML;


    if(data.template_suffix == "RTW"){
      STANDARD_SIZE = 36;
      var sizeHTML = '';
      data.variants.forEach(variant => {
        var optSize = variant.option_size != undefined ? variant.option_size : STANDARD_SIZE;
        sizeHTML += `<li class="HorizontalList__Item${variant.available ? '' : " disable_vairant"}">
            <input id="option-${optSize}" 
              class="SizeSwatch__Radio custom_variant" type="radio" name="properties[_size]"
              value="${optSize}" data-option-position="2">
            <label for="option-${optSize}" class="SizeSwatch">${optSize}</label>
          </li>`;
        STANDARD_SIZE = STANDARD_SIZE + 2;
      });
      STANDARD_SIZE = 36;
      
      var noScript = `<noscript data-standard-size-html>
      <div class="rtw-mobile-slide">
        <div class="rtw-size-wrap">
          <div class="rtw-size-top">
            <p>Select Size</p>
            <button class="pro-fitsmart-guide btn-ripple" data-id="product-rtw-size-guide" data-pro-fitsmart-guide="">Size Guide</button>
          </div>
          <div class="rtw-size-header hide"><div class="rtw-rec-size"></div></div>
        </div>
        <input type="hidden" class="preferredFit" name="properties[_designType]" value="READY_TO_WEAR">
        <div class="ProductForm__Variants"><div class="ProductForm__Option"></div>
          <div class="ProductForm__Option"><ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">${sizeHTML}</ul></div>
        </div>
      </div>
      <a href="/products/${data.handle}" data-product-id="${data.id}" class="pro-quickview-view-details hide">VIEW DETAILS</a>
      </noscript>`;
    }else{
      var sizeHTML;
      if(data.product_type == "Shirt"){
        sizeHTML = `<div class="Pair__Lists">
          <div class="List__numbers">
            <div class="Property__Field">
              <input id="StandardSize__36" type="radio" name="properties[_Standard Size?]" value="xs">
              <label for="StandardSize__36">36</label>
            </div>
            <div class="Property__Field">
              <input id="StandardSize__38" type="radio" name="properties[_Standard Size?]" value="s">
              <label for="StandardSize__38">38</label>
            </div>
            <div class="Property__Field">
              <input id="StandardSize__40" type="radio" name="properties[_Standard Size?]" value="m">
              <label for="StandardSize__40">40</label>
            </div>
            <div class="Property__Field">
              <input id="StandardSize__42" type="radio" name="properties[_Standard Size?]" value="l">
              <label for="StandardSize__42">42</label>
            </div>
            <div class="Property__Field">
              <input id="StandardSize__44" type="radio" name="properties[_Standard Size?]" value="xl">
              <label for="StandardSize__44">44</label>
            </div>
            <div class="Property__Field">
              <input id="StandardSize__46" type="radio" name="properties[_Standard Size?]" value="xxl">
              <label for="StandardSize__46">46</label>
            </div>
          </div>
        </div>`;
      // }else if(data.product_type== "Bundi"){
      }else{
        // console.log("else data",data);
        var bundiSize = '';
        data.variants.forEach(variant => {
          var optSize = variant.option_size != undefined ? variant.option_size : STANDARD_SIZE;
          optSize = String(optSize);
          // console.log("optSize",optSize);
          // console.log("variant.option_size",variant.option_size);
          bundiSize += `<div class="Property__Field${variant.available ? '' : " disabled"}">
              <input id="StandardSize__${optSize}" type="radio" name="properties[_Standard Size?]" value="${data.product_type == 'T-Shirts' ? optSize?.toLowerCase() : optSize}">
              <label for="StandardSize__${optSize}">${optSize}</label>
            </div>`;
          STANDARD_SIZE = STANDARD_SIZE + 2;
        });
        sizeHTML = `<div class="Pair__Lists"><div class="List__numbers">${bundiSize}</div></div>`;
        STANDARD_SIZE = 28;
      }


      var designDetails = '';
      var fCust = '';
      data.metafields.forEach(metaF => {
        if(metaF.key == "featured_customisations"){
          fCust = metaF.value;
        }
      });
      if(data.product_type == "Shirt"){
        if(data.tags.includes("Product Type_Customisable")){
        designDetails = `
        <div class="pro-customise-wrap">
          <div class="pro-customise-wrap-inner">
          <div class="ProductElements__Name pro-customise-text-wrap">
            <div class="pro-customise-text"><span class="pro-customise-text-span">Design Details</span></div>
            <div class="pro-customise-custom-btn customize-shirt btn-ripple" data-customise-custom-btn>Edit Design</div>
          </div>
          <div class="pro-customise-content">${fCust}</div>
          <span class="pro-customise-design-toast-msg hide">To edit design, select size first</span>
          </div>
        </div>`;
        }
      }else if(data.product_type != "T-Shirts" && data.product_type != "Jackets" && data.product_type != "Bundi"){
        designDetails = `
        <div class="pro-customise-wrap">
          <div class="pro-customise-wrap-inner">
          <div class="ProductElements__Name pro-customise-text-wrap">
            <div class="pro-customise-text"><span class="pro-customise-text-span">Customise your pair</span></div>
            <div class="pro-customise-custom-btn semi_customizebtn btn-ripple" data-customise-custom-btn>Edit Design</div>
          </div>
          <div class="pro-customise-content">${fCust}</div>
          <span class="pro-customise-design-toast-msg hide">To edit design, select size first</span>
          </div>
        </div>`;
      }
      
      var noScript = `<noscript data-standard-size-html>
        <div class="ProductSize__ShirtStandardSize hide" data-pro-standard-size-main>
          <p class="ProductElements__Name">
            <span class="text-wrap"><span class="text-wrap-span">Select Size</span></span>
            <button class="pro-fitsmart-guide btn-ripple" data-id="product-standard-size-guide" data-pro-fitsmart-guide>Size Guide</button>
          </p>
          <span class="pro-select-standard-size-toast-msg hide">Select your garment size</span>
          <div class="standard-rec-size-content hide">
            Your last selected size : <span class="standard-rec-size" data-standard-rec-size></span>
          </div>
          ${sizeHTML}
        </div>

        <div class="ProductElements__Name pro-need-more-main hide" data-pro-need-more-range>
          <div class="ProductElements__Name pro-need-more-text-wrap">
            <div class="pro-need-more-ranges-text">Prefer a Custom Size?</div>
            ${document.body.classList.contains("logged") ? `<div class="pro-add-custom-size-btn btn-ripple" data-add-custom-size-btn>Add Custom Size</div>` : `<div class="pro-add-custom-size-btn btn-ripple" data-show-shopped-with-us-popup-btn>Add Custom Size</div>` }
          </div>
        </div>
        <div class="ProductElements__Name pro-saved-sizing-main hide" data-pro-saved-sizing>
          <div class="ProductElements__Name pro-saved-sizing-wrap">
            <div class="pro-saved-sizing-text">${data.product_type} Sizing</div>
            <div class="pro-add-custom-size-btn btn-ripple" data-add-custom-size-btn><span></span>Edit Custom Size</div>
          </div>
          <div class="pro-updated-size-details hide">
            <span class="your-size-text">Your size is saved with us.</span> <span data-pro-updated-size-by>You</span><br>
            <span>updated your size on</span> <span data-pro-updated-size-date></span>
          </div>
        </div>
        
        ${designDetails}
        <a href="/products/${data.handle}" data-product-id="${data.id}" class="pro-quickview-view-details hide">VIEW DETAILS</a>
      </noscript>`;
    }
    html += noScript;
    html += `</div>`;
  }
  return html;
}

let mainIDs = [];
function buildCollPage(result,prev,isfilter){
  console.log("buildCollPage",result.products);
  let prodObj = result.products;
  prodObj.forEach((data) => {
  mainIDs.push((data));
  });
  let pageHtml = '';
  let dataIndex = 0;
  result.products.forEach((data,index) => {
    // remove seo.hidden products
    let seoHidden = data.metafields.filter(n => { return n.key == "hidden" && n.value == "1" });
    if(seoHidden.length == 0){
      // console.log("data",data);
      pageHtml += buildCollItem(data,dataIndex);
      dataIndex++;
    }else{
      seoHiddenProducts++;
    }
  });
  if(document.querySelector(".boost-pfs-filter-products .Grid__Cell")){
    if(prev){
      document.querySelector(".boost-pfs-filter-products .Grid__Cell:first-child").outerHTML = pageHtml + document.querySelector(".boost-pfs-filter-products .Grid__Cell:first-child").outerHTML;

      let collCount = Number(document.querySelector(`[data-mobile-count]`).dataset.mobileCount);
      let rowCount = 48 / collCount;
      if(window.innerWidth > 1024){
        collCount = Number(document.querySelector(`[data-desktop-count]`).dataset.desktopCount);
        rowCount = 48 / collCount;
      }
      // console.log("count>>>>",collCount,"rowCount",rowCount);
      document.body.style.overflow = 'hidden';
      document.body.style.overflow = 'scroll';

      var getHeight = 0;
      document.querySelectorAll(`.boost-pfs-filter-products .Grid__Cell[data-page="${currentPage}"]:nth-child(${collCount}n + 1)`).forEach(item => {
          getHeight += item.getBoundingClientRect().height;
      });
      console.log("HEIGHT>>>> in the buildCollPage",getHeight);
      console.log(Number(localStorage.setScrollPositionForColl),"Number(localStorage.setScrollPositionForColl)");
      
      window.scrollTo(0,(window.scrollY+getHeight));
      if(document.querySelector(".custom-boost-pfs-filter-top-loader")) document.querySelector(".custom-boost-pfs-filter-top-loader").classList.add("hide");
    }else if(isfilter){
      document.querySelector(".boost-pfs-filter-products").innerHTML = pageHtml;
    }else{
      document.querySelector(".boost-pfs-filter-products .Grid__Cell:last-child").outerHTML += pageHtml;
    }
    if(document.querySelector(".custom-boost-pfs-filter-bottom-loader")) document.querySelector(".custom-boost-pfs-filter-bottom-loader").classList.add("hide");
  }else{
    document.querySelector(".boost-pfs-filter-products").innerHTML = pageHtml;    
    var scrollInterval;
    if(localStorage.setScrollPositionForColl != undefined && Number(localStorage.setScrollPositionForColl) != 0){
    scrollInterval = setInterval(() => {
      console.log("scrollInterval");
      if(document.readyState == "complete"){
        // console.log("complete ready state");
        
        window.scroll(0,Number(localStorage.setScrollPositionForColl)); // commented for scrolling issue on back to PLP from PDP.
        console.log(Number(localStorage.setScrollPositionForColl),"Number(localStorage.setScrollPositionForColl)");
        
        localStorage.setScrollPositionForColl = 0;
        clearInterval(scrollInterval);
        // console.log("cleard scrollInterval");
        
        if(localStorage.collPageNeedToLoadNextPage == "true"){
          if(getUrlParameterBOOST("page") != false){
            let currPage = Number(getUrlParameterBOOST("page"));
            // currPage = currPage + 1;
            console.log("buildCollPage -> currPage",currPage);
            
            window.history.replaceState({},document.title,location.href.replace(`page=${currPage}`,`page=${currPage+1}`));
          }else if(location.search != ""){
            window.history.replaceState({},document.title,`${location.href}&page=2`);
          }else{
            window.history.replaceState({},document.title,`${location.href}?page=2`);
          }
          localStorage.collPageNeedToLoadNextPage = false;
          initCollpageCUSTOM();
          console.log("buildcoll function initCollpage");
          
        }
      }
    },500);
    }
  }
  setTimeout(() => {
    if(window.innerWidth > 1024){
      swiperslider();
    }else{
      mobswiperslider();
    }
  },2000);

  // reInit wishlist buttons
  let timeout = 2500;
  let wishlistButtons = document.querySelectorAll(".boost-pfs-filter-products .swym-button.swym-add-to-wishlist-view-product");
  if(wishlistButtons.length > 0 && document.readyState == "complete" && location.href.includes("?page")){
    timeout = 1000;
  }
  setTimeout(() => {
    if(_swat) _swat.initializeActionButtons("body");
  },timeout);
  
}
var TICK_SVG = `<svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.54087 8.82137L12.2165 1.04132C12.3288 0.927234 12.3918 0.772586 12.3918 0.611346C12.3918 0.450106 12.3288 0.29546 12.2165 0.181375C12.1613 0.123972 12.0954 0.0783496 12.0227 0.0471989C11.9499 0.0160483 11.8717 0 11.7927 0C11.7137 0 11.6355 0.0160483 11.5628 0.0471989C11.49 0.0783496 11.4241 0.123972 11.369 0.181375L4.11711 7.53146L1.02289 4.39185C0.967761 4.33445 0.901866 4.28883 0.829087 4.25768C0.756308 4.22653 0.678118 4.21048 0.599128 4.21048C0.520139 4.21048 0.441949 4.22653 0.36917 4.25768C0.296391 4.28883 0.230496 4.33445 0.175371 4.39185C0.0630751 4.50594 0 4.66059 0 4.82183C0 4.98307 0.0630751 5.13771 0.175371 5.2518L3.69335 8.82137C3.74872 8.87825 3.81472 8.92334 3.88749 8.95399C3.96026 8.98464 4.03832 9.00023 4.11711 8.99985C4.1961 9.00166 4.27458 8.98672 4.34755 8.95599C4.42052 8.92525 4.48636 8.87941 4.54087 8.82137Z" fill="#5B5B5B" fill-opacity="0.4"/>
</svg>`;
function buildFilters(result){
  console.log("buildFilters>>>>>>",result.total_product);

  // result.products.length
  if(document.querySelector(".collItemCount")) document.querySelector(".collItemCount").classList.remove("hide"), document.querySelector(".collItemCount").innerHTML = `${result.total_product}`;
  
  let filterOptTitles = '';
  let filterOptFilters = '';
  let forActive = ' active';
  result.filter.options.forEach(option => {
    if(option.values && option.values.length > 0){
      filterOptTitles += `<button class="filter-category-btn${forActive}" data-id="${option.filterOptionId}" data-filter-name="${option.label}" data-filter-category-btn><span>${option.label}</span></button>`;
      
      filterOptFilters += `<div class="filter-category_filter${forActive}" data-id="${option.filterOptionId}">
      <div class="filter-category_filter-head"><input type="text" placeholder="Search" data-filter-search-input></div>
      <div class="filter-category_filter-list">`;
      if(option.displayType == 'swatch'){
        option.values.forEach(value => {
          if(value.doc_count != 0){
            // console.log("valuevalue",swatchSettings);
            
            var color = value.key.includes("_") ? value.key.split("_")[1].toLowerCase() : value.key.toLowerCase();
            var url = "";
            if(swatchSettings[`${value.key.toLowerCase()}`] != undefined){
              if(swatchSettings[`${value.key.toLowerCase()}`].type != "image") color = swatchSettings[`${value.key.toLowerCase()}`].colorCodes[0];
              url = swatchSettings[`${value.key.toLowerCase()}`].imageUrl;
            }
            filterOptFilters += `<div class="filter-category_filter-item filter-category_filter-item-swatch" data-count="${value.doc_count}" data-value="${value.key.toLowerCase()}">
            <input type="checkbox" id="filter-${option.filterOptionId}-${value.key}" value="${value.key.replaceAll(" ","+")}" data-id="${option.filterOptionId}">
            ${TICK_SVG}
            <label for="filter-${option.filterOptionId}-${value.key}">
            <span data-swatch-img='${url}' class="color-ele" style="background-color:${color};${url != "" ? `background-image: url(${url})` : "" }"></span>
            <span>${value.key.includes("_") ? value.key.split("_")[1] : value.key}</span>
            <span class="count-span">${value.doc_count}</span>
            </label>
            </div>`;
          }
        });
      }else{
        if(option.filterType == "price"){
          option.values.forEach(value => {
            var valueKey = value.key;
            var valueKeyArr = value.key.split("-");
            if(valueKeyArr[0] == "*"){
              valueKey = `Under ₹${valueKeyArr[1].slice(0, -3)},${valueKeyArr[1].slice(-3)}`;
            }else if(valueKeyArr[1] == "*"){
              valueKey = `Above ₹${valueKeyArr[0].slice(0, -3)},${valueKeyArr[0].slice(-3)}`;
            }else{
              valueKey = `₹${valueKeyArr[0].slice(0, -3)},${valueKeyArr[0].slice(-3)} - ₹${valueKeyArr[1].slice(0, -3)},${valueKeyArr[1].slice(-3)}`;
            }
            if(value.doc_count != 0){
              filterOptFilters += `<div class="filter-category_filter-item" data-count="${value.doc_count}" data-value="${value.key.toLowerCase()}">
              <input type="checkbox" id="filter-${option.filterOptionId}-${value.key}" value="${value.key.replace("*","").replace("-","%3A").replaceAll(" ","+")}" data-id="${option.filterOptionId}">
              ${TICK_SVG}
              <label for="filter-${option.filterOptionId}-${value.key}">
              <span>${valueKey}</span>
              <span class="count-span">${value.doc_count}</span>
              </label>
              </div>`;
            }
          });
        }else{
          let optionLabel = option.label;
          var collCategoryHTML = `<div class="filter-category_filter-title-wrap mb_show"><div class="filter-category_filter-title">
            <span class="text">${optionLabel}</span>
            <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M13.7144 13.7144C13.5317 13.8971 13.2839 14 13.0254 14C12.7669 14 12.519 13.8971 12.3364 13.7144L6.99986 8.37781L1.66331 13.7144C1.41723 13.9604 1.0584 14.0566 0.722164 13.9665C0.385912 13.8764 0.123384 13.6138 0.0331736 13.2776C-0.0568323 12.9413 0.0392876 12.5825 0.285364 12.3364L5.62191 6.99986L0.285364 1.66331C0.0392866 1.41723 -0.0568323 1.0584 0.0331736 0.722165C0.123349 0.385912 0.385899 0.123384 0.722164 0.033174C1.05842 -0.0568322 1.41724 0.0392876 1.66331 0.285364L6.99986 5.62191L12.3364 0.285364C12.5825 0.0392867 12.9413 -0.0568322 13.2776 0.033174C13.6138 0.12335 13.8763 0.385899 13.9665 0.722165C14.0566 1.05842 13.9604 1.41724 13.7144 1.66331L8.37781 6.99986L13.7144 12.3364C13.8971 12.519 14 12.7669 14 13.0254C14 13.2839 13.8971 13.5316 13.7144 13.7144Z" fill="#151515"/>
            </svg>
            </span>
          </div></div>
          <div class="filter-dropdowns-item-list">`;
          // console.log("value.doc_count",result.filter.options);
          option.values.forEach(value => {
            if(value.doc_count != 0){
              filterOptFilters += `<div class="filter-category_filter-item" data-count="${value.doc_count}" data-value="${value.key.toLowerCase()}">
              <input type="checkbox" id="filter-${option.filterOptionId}-${value.key}" value="${value.key.replaceAll(" ","+").replaceAll("%","%25")}" data-id="${option.filterOptionId}">
              ${TICK_SVG}
              <label for="filter-${option.filterOptionId}-${value.key}">
              <span>${value.key.includes("_") ? value.key.split("_")[1] : value.key}</span>
              <span class="count-span">${value.doc_count}</span>
              </label>
              </div>`;

              if(option.filterOptionId == "pf_m_::custom::product_type" && option.values.length == 1){
                let cMade = option.values.find(item => item.key === "Custom Made");
                if(cMade == undefined){
                  // filterOptFilters += `<div class="filter-category_filter-item hide" data-count="40" data-value="custom made">
                  // <input type="checkbox" id="filter-pf_m_::custom::product_type-Custom Made" value="Custom+Made" data-id="pf_m_::custom::product_type">
                  // <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  // <path d="M4.39728 8.82137L11.8302 1.04132C11.9389 0.927234 12 0.772586 12 0.611346C12 0.450106 11.9389 0.29546 11.8302 0.181375C11.7768 0.123972 11.713 0.0783496 11.6425 0.0471989C11.572 0.0160483 11.4963 0 11.4198 0C11.3433 0 11.2676 0.0160483 11.1971 0.0471989C11.1267 0.0783496 11.0628 0.123972 11.0095 0.181375L3.98693 7.53146L0.990541 4.39185C0.937159 4.33445 0.873348 4.28883 0.802871 4.25768C0.732393 4.22653 0.656675 4.21048 0.580183 4.21048C0.503692 4.21048 0.427975 4.22653 0.357497 4.25768C0.287019 4.28883 0.223208 4.33445 0.169826 4.39185C0.0610807 4.50594 0 4.66059 0 4.82183C0 4.98307 0.0610807 5.13771 0.169826 5.2518L3.57657 8.82137C3.63018 8.87825 3.6941 8.92334 3.76456 8.95399C3.83503 8.98464 3.91063 9.00023 3.98693 8.99985C4.06341 9.00166 4.13942 8.98672 4.21008 8.95599C4.28074 8.92525 4.3445 8.87941 4.39728 8.82137Z" fill="currentColor" fill-opacity="0.4"></path>
                  // </svg>
                  // <label for="filter-pf_m_::custom::product_type-Custom Made">
                  // <span>Custom Made</span>
                  // <span class="count-span">40</span>
                  // </label>
                  // </div>`;
                  document.querySelectorAll(`[data-coll-category-filter-item][data-value="custom made"]`).forEach((ele) => {
                    ele.classList.add("disabled");
                  });
                }
                let rMade = option.values.find(item => item.key === "Ready to Ship");
                if(rMade == undefined){
                  // filterOptFilters += `<div class="filter-category_filter-item hide" data-count="94" data-value="ready to ship">
                  // <input type="checkbox" id="filter-pf_m_::custom::product_type-Ready to Ship" value="Ready+to+Ship" data-id="pf_m_::custom::product_type">
                  // <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  // <path d="M4.39728 8.82137L11.8302 1.04132C11.9389 0.927234 12 0.772586 12 0.611346C12 0.450106 11.9389 0.29546 11.8302 0.181375C11.7768 0.123972 11.713 0.0783496 11.6425 0.0471989C11.572 0.0160483 11.4963 0 11.4198 0C11.3433 0 11.2676 0.0160483 11.1971 0.0471989C11.1267 0.0783496 11.0628 0.123972 11.0095 0.181375L3.98693 7.53146L0.990541 4.39185C0.937159 4.33445 0.873348 4.28883 0.802871 4.25768C0.732393 4.22653 0.656675 4.21048 0.580183 4.21048C0.503692 4.21048 0.427975 4.22653 0.357497 4.25768C0.287019 4.28883 0.223208 4.33445 0.169826 4.39185C0.0610807 4.50594 0 4.66059 0 4.82183C0 4.98307 0.0610807 5.13771 0.169826 5.2518L3.57657 8.82137C3.63018 8.87825 3.6941 8.92334 3.76456 8.95399C3.83503 8.98464 3.91063 9.00023 3.98693 8.99985C4.06341 9.00166 4.13942 8.98672 4.21008 8.95599C4.28074 8.92525 4.3445 8.87941 4.39728 8.82137Z" fill="currentColor" fill-opacity="0.4"></path>
                  // </svg>
                  // <label for="filter-pf_m_::custom::product_type-Ready to Ship">
                  // <span>Ready to Ship</span>
                  // <span class="count-span">94</span>
                  // </label>
                  // </div>`;
                  document.querySelectorAll(`[data-coll-category-filter-item][data-value="ready to ship"]`).forEach((ele) => {
                    ele.classList.add("disabled");
                  });
                }
              }else if(option.filterOptionId == "pf_m_::custom::product_type" && option.values.length > 1){
                document.querySelectorAll(`[data-coll-category-filter-item][data-value="custom made"]`).forEach((ele) => {
                  ele.classList.remove("disabled");
                });
                document.querySelectorAll(`[data-coll-category-filter-item][data-value="ready to ship"]`).forEach((ele) => {
                  ele.classList.remove("disabled");
                });
              }

              collCategoryHTML += `<div class="filter-dropdowns-item-single" data-count="${value.doc_count}" data-id="${value.key.replaceAll(" ","+").replaceAll("%","%25")}" data-value="${value.key.toLowerCase()}">
              <span class="icon"><svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.39728 8.82137L11.8302 1.04132C11.9389 0.927234 12 0.772586 12 0.611346C12 0.450106 11.9389 0.29546 11.8302 0.181375C11.7768 0.123972 11.713 0.0783496 11.6425 0.0471989C11.572 0.0160483 11.4963 0 11.4198 0C11.3433 0 11.2676 0.0160483 11.1971 0.0471989C11.1267 0.0783496 11.0628 0.123972 11.0095 0.181375L3.98693 7.53146L0.990541 4.39185C0.937159 4.33445 0.873348 4.28883 0.802871 4.25768C0.732393 4.22653 0.656675 4.21048 0.580183 4.21048C0.503692 4.21048 0.427975 4.22653 0.357497 4.25768C0.287019 4.28883 0.223208 4.33445 0.169826 4.39185C0.0610807 4.50594 0 4.66059 0 4.82183C0 4.98307 0.0610807 5.13771 0.169826 5.2518L3.57657 8.82137C3.63018 8.87825 3.6941 8.92334 3.76456 8.95399C3.83503 8.98464 3.91063 9.00023 3.98693 8.99985C4.06341 9.00166 4.13942 8.98672 4.21008 8.95599C4.28074 8.92525 4.3445 8.87941 4.39728 8.82137Z" fill="currentColor" fill-opacity="0.4"></path> </svg></span>
              <span>${value.key.includes("_") ? value.key.split("_")[1] : value.key}</span>
              <span class="count-span">${value.doc_count}</span>
              </div>`;
            }
          });
          collCategoryHTML += `</div><div class="filter-dropdowns-btn-wrap"><button class="Button Button--primary Button--full filter-dropdowns-apply-btn" data-filter-dropdowns-apply-btn>APPLY</button></div>`;
          if(option.filterOptionId == "pf_pt_category"){
            document.querySelectorAll(`.filter-dropdowns-item[data-filter="pf_pt_category"] [data-filter-dropdowns-item-content]`).forEach(filterWrap => {
              filterWrap.innerHTML = collCategoryHTML;
            });
          }else if(option.filterOptionId == "pf_opt_size"){
            // console.log("opt_size",collCategoryHTML);
            document.querySelectorAll(`.filter-dropdowns-item[data-filter="pf_opt_size"] [data-filter-dropdowns-item-content]`).forEach(filterWrap => {
              filterWrap.innerHTML = collCategoryHTML;
            });
          }
        }
      }
      filterOptFilters += `</div></div>`;
      forActive = "";
    }
  });
  let filtersHtml = `<div class="filter-category-list">${filterOptTitles}</div><div class="filter-category_filters">${filterOptFilters}</div>`;
  document.querySelector(".boost-pfs-filter-tree.boost-pfs-filter-tree-v").innerHTML = filtersHtml;

  $(`[data-filter-dropdowns-item]`).removeClass("active-filter");
  $(`.coll-category-filter .coll-category-filter-item`).removeClass("active");

  // set active filters
  const searchParams = new URLSearchParams(location.search);
  let catFilterRTW = 0;
  for (const p of searchParams) {
    // console.log(p,"searchParamssearchParams");
    if(p[0] == "sort"){
      document.querySelector(`[data-sort-list] [data-sort-item].is-selected`)?.classList.remove("is-selected");
      document.querySelector(`[data-sort-list] [data-sort-item][data-value="${p[1]}"]`)?.classList.add("is-selected");
    }else{
      var val = p[1];
      val = p[1].replaceAll("%","%25").replaceAll(" ","+");
      if(p[0] == "pf_p_price"){
        val = p[1].replace(":","%3A");
      }
      if(val == "Ready+to+Ship"){
        catFilterRTW = 1;
      }
      // console.log("val",val,"price",document.querySelector(`[data-collection-filters] input[value="${val}"]`));
      if(document.querySelector(`[data-collection-filters] input[value="${val}"]`)){
        // console.log("filllllter",document.querySelector(`[data-filter-category-btn][data-id="${p[0]}"]`));
        document.querySelector(`[data-filter-category-btn][data-id="${p[0]}"]`)?.classList.add("active-filter");
        document.querySelector(`[data-collection-filters] input[value="${val}"]`).setAttribute("checked","true");
      }
      // console.log("val",val);
      if (val === "ready-to-wear") {
        const items = $('.coll-category-filter-item[data-value="ready to ship"]');
        if (items) {
          items.addClass("active");
        }
      }
      if (val === "Semi-Stitched" || val === "Hemming" || val === "Customisable") {
        const items = $('.coll-category-filter-item[data-value="custom made"]');
        if (items) {
          items.addClass("active");
        }
      }
      if(document.querySelector(`.coll-category-filter .filter-dropdowns-item-single[data-id="${val}"]`)){
        // console.log("filllllter",document.querySelector(`[data-filter-category-btn][data-id="${p[0]}"]`));
        $(`[data-filter-dropdowns-item][data-filter="${p[0]}"]`).addClass("active-filter");
        $(`.coll-category-filter .filter-dropdowns-item-single[data-id="${val}"]`).addClass("active");
      }
      if(document.querySelector(`.coll-category-filter .coll-category-filter-item[data-id="${val}"]`)){
        $(`.coll-category-filter .coll-category-filter-item[data-id="${val}"]`).addClass("active");
      }
      // if(document.querySelector(`.coll-category-filter [data-coll-category-filter-item][data-id="${val}"]`)){
      //   $(`.coll-category-filter .coll-category-filter-item[data-id="${val}"]`).addClass("active");
      // }
    }
  }
  if(catFilterRTW == 1){
    // document.querySelectorAll(`.coll-category-filter [data-coll-category-filter-item][data-id="Ready+to+Ship"]`).forEach(item => {
    //   item.add("active");
    // });
  }else{
    // document.querySelectorAll(`.coll-category-filter [data-coll-category-filter-item][data-id="Ready+to+Ship"]`).forEach(item => {
    //   item.remove("active");
    // });
  }
  if(location.search.includes("sort")){
    document.querySelector("[data-sort-button]")?.classList.add("active");
  }else{
    document.querySelector("[data-sort-button]")?.classList.remove("active");
    document.querySelector(`[data-sort-list] [data-sort-item].is-selected`)?.classList.remove("is-selected");
    // document.querySelector(`[data-sort-list] [data-sort-item][data-value="manual"]`)?.classList.add("is-selected");
    document.querySelector(`[data-sort-list] [data-sort-item][data-value="manual"]`)?.classList.add("is-selected");
  }

  if(location.search.includes("pf_")){
    document.querySelector(".collection-section-main")?.classList.add("filterApplied");
  }else{
    document.querySelector(".collection-section-main")?.classList.remove("filterApplied");
    $(`[data-filter-category-btn]`).removeClass("active-filter");
    $(`[data-filter-dropdowns-item]`).removeClass("active-filter");
  }
  // collection-section-main
  
}

function initCollpageCUSTOM(prev = false,isfilter = false){
  console.log("initCollpageCUSTOM>>>>>>>>>>>>>>>>");
  const myHeaders = new Headers();
  myHeaders.append("accept", "application/json, text/plain, */*");
  // myHeaders.append("Accept-Encoding", "gzip");
  myHeaders.append("Connection", "Keep-Alive");
  myHeaders.append("Host", "services.mybcapps.com");
  // myHeaders.append("User-Agent", "okhttp/4.9.2");

  // myHeaders.append("user-agent", "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36");

  myHeaders.append("Sec-Fetch-Site", "cross-site");
  myHeaders.append("Sec-Fetch-Dest", "script");
  myHeaders.append("Accept-Language", "en-us");
  myHeaders.append("Sec-Fetch-Mode", "no-cors");
  // myHeaders.append("Host", "services.mybcapps.com");
  // myHeaders.append("User-Agent", "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6.1 Safari/605.1.15");
  myHeaders.append("Referer", "https://www.bombayshirts.com/");
  myHeaders.append("Accept-Encoding", "gzip, deflate, br");
  // myHeaders.append("Connection", "keep-alive");
  
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };
  var page = 1;
  if(getUrlParameterBOOST("page") != false){
    page = Number(getUrlParameterBOOST("page"));
  }

  // var sort = "created-descending";
  var sort = "created-descending";
  if(getUrlParameterBOOST("sort") != false){
    sort = getUrlParameterBOOST("sort");
  }


  let PARAMS_STRING = "";
  let cntr = 0;
  const searchParams1 = new URLSearchParams(location.search);
  for (const p of searchParams1) {
    // console.log(p);
    let pVal = p[1].replaceAll("%","%25");
    // console.log("initCollpageCUSTOM p[1]p[1]",p[1]);
    console.log("initCollpageCUSTOM p[1]p[1]",pVal);
    if(cntr == 0){
      console.log("if cntr 0");
      if(p[0].includes("pf")){
        PARAMS_STRING += `${p[0]}%5B%5D=${pVal}`;
      }else{
          PARAMS_STRING += `${p[0]}=${pVal}`;
        console.log(PARAMS_STRING,"PARAMS_STRING cntr 0");
      }
      cntr++;
    }else{
      console.log("else cntr !0");
      if(p[0].includes("pf")){
        PARAMS_STRING += `&${p[0]}%5B%5D=${pVal}`;
      }else{
        PARAMS_STRING += `&${p[0]}=${pVal}`;
        console.log("else cntr !0",PARAMS_STRING);
      }
    }
  }
  if (!searchParams1.has("sort")) {
    PARAMS_STRING = PARAMS_STRING
      ? `${PARAMS_STRING}&sort=manual`
      : "sort=manual";
  } 
  if(PARAMS_STRING == ""){
    PARAMS_STRING = "page=1";
  }
  // PARAMS_STRING = PARAMS_STRING.replaceAll("%","%25").replaceAll(" ","%20");
  // console.log("PARAMS_STRING",PARAMS_STRING);
  var URL = `https://services.mybcapps.com/bc-sf-filter/filter?&build_filter_tree=true&limit=${PRODUCT_LIMIT}&${PARAMS_STRING}&product_available=true&variant_available=true&sort_first=available&t=${Date.now()}&shop=bombayshirts-india-prod.myshopify.com&collection_scope=${document.querySelector(".collection-section-main").dataset.id}`;
  
  fetch(URL, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    // console.log("result",result);
    if(result.total_product == 0){
      let noResults = `<div class="boost-pfs-filter-message"><p><em>Sorry, no products matched your selection</em></p></div>`;
      document.querySelector(".boost-pfs-filter-products").innerHTML = noResults;
    }else{
      console.log("log of initCollpageCUSTOM ");
      
      buildCollPage(result,prev,isfilter);
    }
    if(allowFilters){
      buildFilters(result);
    }
  })
  .catch((error) => console.error(error));
}
initCollpageCUSTOM();
var allowFilters = true;

// infinite scroll
let temp = 0;
let tempPrev = 0;
let lastScrollTop = 0;
let scrollingUp = false;
$(window).scroll(function(){

  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // Scrolling Down
    // console.log("Scrolling Down");
    // console.log("Scrolling Down");
    if($(`.boost-pfs-filter-bottom-pagination .Pagination__NavItem[rel="next"]`).length){
      let a = isScrolledIntoView($(".boost-pfs-filter-bottom-pagination"));
      // console.log("a = " +a );
      // if(a == true && document.querySelectorAll(`.boost-pfs-filter-products .Grid__Cell[data-page="${currentPage}"]`).length == (PRODUCT_LIMIT - seoHiddenProducts) || (!document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`) && (window.scrollY+window.innerHeight) > (document.body.clientHeight-100)) || (document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`) && (window.scrollY+window.innerHeight) > (document.body.clientHeight))){
      if(a == true && document.querySelectorAll(`.boost-pfs-filter-products .Grid__Cell[data-page="${currentPage}"]`).length == (PRODUCT_LIMIT - seoHiddenProducts) || (document.querySelectorAll(`.boost-pfs-filter-products .Grid__Cell[data-page="${currentPage}"]`).length == (PRODUCT_LIMIT - seoHiddenProducts)) && (!document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`) && (window.scrollY+window.innerHeight) > (document.body.clientHeight-100)) || (document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`) && (window.scrollY+window.innerHeight) > (document.body.clientHeight - 5))){
        // console.log("temp>>>>>>>>>>>>>>>>>>>>",temp);
        if(temp == 1 && document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`) && (window.scrollY+window.innerHeight) >= (document.body.clientHeight-5)){
          temp = 0;
          // console.log("temp inside>>>>>>>>>>>>>>>>>>>>",temp);
        }
        if(temp == 0){
          // console.log("if temp Scrolling Down coll page");
          console.log("infinite if currPage");
          if(document.querySelector(".custom-boost-pfs-filter-bottom-loader") && document.querySelector(".boost-pfs-filter-products").innerHTML != "") document.querySelector(".custom-boost-pfs-filter-bottom-loader").classList.remove("hide");
          if(getUrlParameterBOOST("page") == false){
            // location.href + `?page=2`;
            if(location.search == ""){
              window.history.replaceState({},document.title,(location.href + `?page=2`));
            }else{
              window.history.replaceState({},document.title,(location.href + `&page=2`));
            }
            currentPage = 2;
          }else{
          // console.log("getUrlParameterBOOST else Scrolling Down coll page");
            // let currPage = Number(getUrlParameterBOOST("page"));
            let currPage = Number(document.querySelector(`.boost-pfs-filter-products .Grid__Cell:last-child`).dataset.page);
            console.log("infinite else currPage",currPage);
            currentPage = currPage + 1;
            // location.href.replace(`page=${currPage}`,`page=${currPage+1}`);
            window.history.replaceState({},document.title,(location.href.replace(`page=${getUrlParameterBOOST("page")}`,`page=${currPage+1}`)));
          }
          seoHiddenProducts = 0;
          initCollpageCUSTOM();
          console.log("infinite scroll initCollpage");
          
          // debugger;
          temp = 1;
        }
      }else{
        temp = 0;
      }
    }
  }else{
    // Scrolling Up
    // console.log("Scrolling Up",scrollTop);
    let prevP = false;
    // if(scrollTop <= (window.innerHeight*2)){
    if(scrollTop == 0){
      // console.log("scrollTop",scrollTop);
      // debugger;
      prevP = true;
    }
    if(prevP == true){
      if(tempPrev == 0 && Number(document.querySelector(`.boost-pfs-filter-products .Grid__Cell:first-child`).dataset.page) > 1){
        // console.log("Scrolling Up");
        if(document.querySelector(".custom-boost-pfs-filter-top-loader")) document.querySelector(".custom-boost-pfs-filter-top-loader").classList.remove("hide");
        if(getUrlParameterBOOST("page") == false){
          // location.href + `?page=2`;
          // window.history.replaceState({},document.title,(location.href + `?page=2`));
        }else{
          // let currPage = Number(getUrlParameterBOOST("page"));
          let currPage = Number(document.querySelector(`.boost-pfs-filter-products .Grid__Cell:first-child`).dataset.page);
          currentPage = currPage - 1;
          // console.log("currentPage",currentPage);
          // location.href.replace(`page=${currPage}`,`page=${currPage-1}`);
          window.history.replaceState({},document.title,(location.href.replace(`page=${getUrlParameterBOOST("page")}`,`page=${currPage-1}`)));
        }
        // document.body.style.overflow = 'hidden';
        initCollpageCUSTOM(true);
        tempPrev = 1;
      }
    }else{
      tempPrev = 0;
    }
  }
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
});
function isScrolledIntoView(elem){
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  // if(document.querySelector(`[data-action="change-layout-mode"][data-count="12"][data-grid-type="desktop"].is-active`)){
  //   elemTop = docViewTop;
  // }
  // console.log("elemBottom",elemBottom,"docViewBottom",docViewBottom,"elemTop",elemTop,"docViewTop",docViewTop);
  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function removeTempActive(){
  document.querySelectorAll(`.filter-category-list .filter-category-btn`).forEach(btn => {
    btn.classList.remove("temp-active");
  });
}
/*
=================================================
Coll page ======> start
=================================================
*/

// $(document).on("click",".boost-pfs-filter-products .Grid__Cell a",function(e){
//   e.preventDefault();
//   console.log("eeee",e);
//   if(!e.target.classList.contains("swym-button")){
//   if(location.search != "" && getUrlParameterBOOST("page") != false){
//     let url = location.href.replace(`page=${getUrlParameterBOOST("page")}`,`page=${$(this).closest(".Grid__Cell").attr("data-page")}`);
//     console.log("url",url);
//     window.history.replaceState({},document.title,url);
//   }
//   let prodPage = $(this).closest(".Grid__Cell").attr("data-page");
//   console.log("prodPage",prodPage,$(this).closest(".Grid__Cell").outerHeight());
//   console.log("this offset",$(this).closest(".Grid__Cell")[0].offsetTop);
//   console.log("first prod offset",$(`.Grid__Cell[data-page="${prodPage}"]`)[0].offsetTop);
//   var position = $(this).closest(".Grid__Cell")[0].offsetTop - $(`.Grid__Cell[data-page="${prodPage}"]`)[0].offsetTop;
//   console.log("position",position);

//   let proIndex = Number($(this).closest(".Grid__Cell").attr("data-index"));
//   if(document.body.clientWidth > 767){
//     let numberToMinus = 0;
//     if(proIndex > 24){
//       numberToMinus = 0;
//       console.log(position,"position for > 24");

//     }
//     if(proIndex >= 12){
//       position += $(`.Grid__Cell.Grid__Cell-banner-kin`).outerHeight() - numberToMinus;
//       console.log(position,"position for >= 12");

//     }
//     if(proIndex >= 24){
//       position += $(`.Grid__Cell.Grid__Cell-banner`).outerHeight() - numberToMinus;
//       console.log(position,"position for >= 24");

//     }
//     if(proIndex >= 36){
//       position += $(`.Grid__Cell.Grid__Cell-banner-ts`).outerHeight() - numberToMinus;
//       console.log(position,"position for >= 36");
//     }
//   }else{
//     let numberToMinus = $(this).outerHeight();
//     if(proIndex >= 6){
//       position += $(`.Grid__Cell.Grid__Cell-banner-kin`).outerHeight() - numberToMinus;
//     }
//     if(proIndex >= 12){
//       position += $(`.Grid__Cell.Grid__Cell-banner`).outerHeight() - numberToMinus;
//     }
//     if(proIndex >= 24){
//       position += $(`.Grid__Cell.Grid__Cell-banner-ts`).outerHeight() - numberToMinus;
//     }
//   }
//   console.log("position 22",position);
//   localStorage.setScrollPositionForColl = position;
//   if(proIndex > 24){
//     localStorage.collPageNeedToLoadNextPage = true;
//   }
//   }
// });


$(document).on("click", ".boost-pfs-filter-products .Grid__Cell a", function (e) {
  if (e.target.classList.contains("swym-button")) return;

  // e.preventDefault();

  const $cell = $(this).closest(".Grid__Cell");
  const prodPage = Number($cell.data("page"));
  const proIndex = Number($cell.data("index"));

  // console.log("Clicked product → page:", prodPage, "index:", proIndex);

  if (location.search && prodPage) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", prodPage);
    window.history.replaceState({}, document.title, url.toString());
  }

  const firstProductOfPage = document.querySelector(
    `.Grid__Cell[data-page="${prodPage}"]`
  );

  if (!firstProductOfPage) return;

  let position =
    $cell[0].offsetTop - firstProductOfPage.offsetTop;

  // console.log("Base position:", position);

  const isDesktop = document.body.clientWidth > 767;
  const cardHeight = $cell.outerHeight();

  const bannersDesktop = [
    { index: 36, selector: ".Grid__Cell.Grid__Cell-banner-ts" },
    { index: 24, selector: ".Grid__Cell.Grid__Cell-banner" },
    { index: 12, selector: ".Grid__Cell.Grid__Cell-banner-kin" }
  ];

  const bannersMobile = [
    { index: 24, selector: ".Grid__Cell.Grid__Cell-banner-ts" },
    { index: 12, selector: ".Grid__Cell.Grid__Cell-banner" },
    { index: 6,  selector: ".Grid__Cell.Grid__Cell-banner-kin" }
  ];

  const banners = isDesktop ? bannersDesktop : bannersMobile;

  for (const b of banners) {
    if (proIndex >= b.index && $(b.selector).length) {
      const bannerHeight = $(b.selector).outerHeight();
      position += bannerHeight - (isDesktop ? 0 : cardHeight);
      // console.log("Applied banner:", b.selector, "height:", bannerHeight);
      break; //
    }
  }

  // console.log("Final scroll position:", position);

  localStorage.setScrollPositionForColl = position;

  if (proIndex > 24) {
    localStorage.collPageNeedToLoadNextPage = true;
  }
});

// window.addEventListener("beforeunload", function(){
//   window.scrollTo(0,2);
// });

// data-filter-category-btn click event
$(document).on("click","[data-filter-category-btn]",function(e){
  e.preventDefault();
  // $(`.filter-category_filters .filter-category_filter`).removeClass("active");
  $(this).addClass("active").siblings().removeClass("active");
  $(`.filter-category_filters .filter-category_filter`).removeClass("active");
  $(`.filter-category_filters .filter-category_filter[data-id="${$(this).attr("data-id")}"]`).addClass("active");
});


// data-collection-filters input change event
$(document).on("change",".filter-category_filters .filter-category_filter-list input",function(e){
  e.preventDefault();
  // console.log("apply btn clicked",$(this));
  let paramUrl = `?`;
  let counter = 0;
  document.querySelectorAll(`[data-collection-filters] input:checked`).forEach(input => {
    if(counter == 0){
      paramUrl += `${input.dataset.id}=${input.value}`;
      counter = 1;
    }else{
      paramUrl += `&${input.dataset.id}=${input.value}`;
    }
  });
  if(paramUrl == "?") paramUrl = `${location.origin}${location.pathname}`;  
  // console.log("paramUrl",paramUrl);
  
  const myHeaders = new Headers();
  myHeaders.append("accept", "application/json, text/plain, */*");
  myHeaders.append("Connection", "Keep-Alive");
  myHeaders.append("Host", "services.mybcapps.com");
  myHeaders.append("Sec-Fetch-Site", "cross-site");
  myHeaders.append("Sec-Fetch-Dest", "script");
  myHeaders.append("Accept-Language", "en-us");
  myHeaders.append("Sec-Fetch-Mode", "no-cors");
  myHeaders.append("Referer", "https://www.bombayshirts.com/");
  myHeaders.append("Accept-Encoding", "gzip, deflate, br");  
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow"
  };
  var page = 1;
  // var sort = "manual";
  var sort = "created-descending";
  let PARAMS_STRING = "";
  let cntr = 0;
  const searchParams1 = new URLSearchParams(paramUrl);
  for (const p of searchParams1) {
    // console.log(p);
    let pVal = p[1].replaceAll("%","%25");
    // console.log("p[1]p[1]",p[1]);
    if(cntr == 0){
      if(p[0].includes("pf")){
        PARAMS_STRING += `${p[0]}%5B%5D=${pVal}`;
      }else{
        PARAMS_STRING += `${p[0]}=${pVal}`;
      }
      cntr++;
    }else{
      if(p[0].includes("pf")){
        PARAMS_STRING += `&${p[0]}%5B%5D=${pVal}`;
      }else{
        PARAMS_STRING += `&${p[0]}=${pVal}`;
      }
    }
  }
  if (!searchParams1.has("sort")) {
    PARAMS_STRING = PARAMS_STRING
      ? `${PARAMS_STRING}&sort=manual`
      : "sort=manual";
  } 
  if(PARAMS_STRING == ""){
    PARAMS_STRING = "page=1";
  }
  // PARAMS_STRING = PARAMS_STRING.replaceAll("%","%25").replaceAll(" ","%20");
  // console.log("PARAMS_STRING",PARAMS_STRING);
  var URL = `https://services.mybcapps.com/bc-sf-filter/filter?&build_filter_tree=true&limit=${PRODUCT_LIMIT}&${PARAMS_STRING}&product_available=true&variant_available=true&sort_first=available&t=${Date.now()}&shop=bombayshirts-india-prod.myshopify.com&collection_scope=${document.querySelector(".collection-section-main").dataset.id}`;
  
  fetch(URL, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    document.querySelectorAll(".filter-category_filter-item").forEach(fItem => {
      // filter search drawer changes
      // fItem.classList.add("hide");
    });
    result.filter.options.forEach(option => {
      if(option.values && option.values.length > 0){
        
        if(option.displayType == 'swatch'){
          option.values.forEach(value => {
            var color = value.key.includes("_") ? value.key.split("_")[1].toLowerCase() : value.key.toLowerCase();
            var url = "";
            if(swatchSettings[`${value.key.toLowerCase()}`] != undefined){
              if(swatchSettings[`${value.key.toLowerCase()}`].type != "image") color = swatchSettings[`${value.key.toLowerCase()}`].colorCodes[0];
              url = swatchSettings[`${value.key.toLowerCase()}`].imageUrl;
            }
            let iValue = value.key.replaceAll(" ","+");
            if(document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`)){
              document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").querySelector(".count-span").innerHTML = `${value.doc_count}`;
              if(value.doc_count == 0){
                // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.add("hide");
                document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
              }else{
                // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
              }
            }
          });
        }else{
          if(option.filterType == "price"){
            option.values.forEach(value => {
              let iValue = value.key.replace("*","").replace("-","%3A").replaceAll(" ","+");
              if(document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`)){
                document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").querySelector(".count-span").innerHTML = `${value.doc_count}`;
                if(value.doc_count == 0){
                  // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.add("hide");
                  document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
                }else{
                  // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
                }
              }
            });
          }else{

            // option.values.forEach(value => {
            //   let iValue = value.key.replaceAll(" ","+").replaceAll("%","%25");
            //   // console.log("ele",iValue,document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`));
            //   if(iValue == "Cotton+Linen"){
            //   console.log("ele count=>", value);
            //   }
            //   if(document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`)){
            //     document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").querySelector(".count-span").innerHTML = `${value.doc_count}`;
            //     if(value.doc_count == 0){
            //       // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.add("hide");
            //       // filter search drawer changes
            //       document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
            //     }else{
            //       // filter search drawer changes
            //       // document.querySelector(`.filter-category_filter-list input[value="${iValue}"]`).closest(".filter-category_filter-item").classList.remove("hide");
            //     }
            //   }
            // });
              // fixed collection count issue //
              let filterGroups = document.querySelectorAll(".filter-category");
              result.filter.options.forEach(option => {
                let filterGroup = [...filterGroups].find(
                  el => el.dataset.filterName === option.name
                );
                if (!filterGroup) return;
                option.values.forEach(value => {
                  let iValue = value.key.replaceAll(" ","+").replaceAll("%","%25");
                  let inputEl = filterGroup.querySelector(`input[value="${iValue}"]`);
                  if (!inputEl) return;
                  
                  let item = inputEl.closest(".filter-category_filter-item");
                  item.querySelector(".count-span").innerHTML = `${value.doc_count}`;
                  item.classList.toggle("hide", value.doc_count == 0);
                });
              });
              // fixed collection count issue //
          }
        }
      }
    });
  })
  .catch((error) => console.error(error));

  document.querySelectorAll(".filter-category_filters .filter-category_filter").forEach(filterEleItem => {
    // console.log("aa",filterEleItem,filterEleItem.querySelectorAll("input:checked").length);
    if(filterEleItem.querySelectorAll("input:checked").length > 0){
      // console.log("elelelele====>",document.querySelector(`.filter-category-list .filter-category-btn[data-id="${filterEleItem.dataset.id}"]`))
      document.querySelector(`.filter-category-list .filter-category-btn:not(.active-filter)[data-id="${filterEleItem.dataset.id}"]`)?.classList.add("temp-active");
    }else{
      document.querySelector(`.filter-category-list .filter-category-btn[data-id="${filterEleItem.dataset.id}"]`)?.classList.remove("temp-active");
    }
  });
  
});


// data-collection-filters apply btn click event
$(document).on("click","[data-collection-filters] [data-collection-filters-apply-btn]",function(e){
  e.preventDefault();
  // console.log("apply btn clicked");
  removeTempActive();
  // let paramUrl = `${location.host}${location.pathname}?`;
  let paramUrl = `?`;
  let counter = 0;
  if((location.search != "") || (location.search == "" && document.querySelectorAll(`[data-collection-filters] input:checked`).length > 0)){
    document.querySelectorAll(`[data-collection-filters] input:checked`).forEach(input => {
      if(counter == 0){
        paramUrl += `${input.dataset.id}=${input.value}`;
        counter = 1;
      }else{
        paramUrl += `&${input.dataset.id}=${input.value}`;
      }
    });

    // let defSort = "&sort=created-descending";
    let defSort = "";
    if(getUrlParameterBOOST("sort") != false){
      defSort = `&sort=${getUrlParameterBOOST("sort")}`;
    }
    if(paramUrl != "?"){
      paramUrl += defSort;
    }
    
    if(paramUrl == "?") paramUrl = `${location.origin}${location.pathname}`;
    
    // console.log("paramUrl",paramUrl);
    currentPage = 1;
    window.history.replaceState({},document.title,paramUrl);
    window.scrollTo(0,0);
    initCollpageCUSTOM(false,true);
    document.body.classList.remove("open-coll-filter");    
  }else{
    document.body.classList.remove("open-coll-filter");
  }
});

// close filter drawer
$('[data-collection-filters-close],.CollectionMain .coll-all-overlay,.CollectionMain .close-coll').click(function(){
  if(document.body.classList.contains("open-collection-category")){
    document.body.classList.remove("open-collection-category");
  }
  if(document.body.classList.contains("open-coll-filter")){
    document.body.classList.remove("open-coll-filter");
  }
  if(document.body.classList.contains("open-collection-collection")){
    document.body.classList.remove("open-collection-collection");
  }

  let filterInputs = document.querySelectorAll(".filter-category_filter-item");
  filterInputs.forEach(fInput => {
    fInput.classList.remove("hide");
    fInput.querySelector(".count-span").innerHTML = `${fInput.dataset.count}`;
  });
  removeTempActive();
});

// filter clear all btn click event
$(document).on("click","[data-collection-filters-clear-btn]",function(e){
  e.preventDefault();
  // console.log("clear filter clicked>>>>");
  if(location.search != ""){
    currentPage = 1;
    window.scrollTo(0,0);
    window.history.replaceState({},document.title,`${location.origin}${location.pathname}`);
    initCollpageCUSTOM(false,true);
  }
  removeTempActive();
});

// custom clear filter button class
function updateClearButtonState() {
  const clearBtn = document.querySelector('[data-collection-filters-clear-btn]');
  if (!clearBtn) return;

  const anyActive = !!document.querySelector('.filter-category-btn.active');
  const sectionMain = document.querySelector('.collection-section-main');
  const sectionApplied = sectionMain && sectionMain.classList.contains('filterApplied');

  if (anyActive && sectionApplied) {
    clearBtn.classList.add('btn-ripple', 'Button', 'Button--secondary');
  } else {
    clearBtn.classList.remove('btn-ripple', 'Button', 'Button--secondary');
  }
}

/* Run on initial load */
document.addEventListener('DOMContentLoaded', updateClearButtonState);

/* Run when user clicks filter buttons (delegated jQuery handler kept) */
$(document).on('click', '.filter-category-btn', function () {
  // small delay if the click handler toggles classes asynchronously
  setTimeout(updateClearButtonState, 50);
});

/* Also update when left-side category items are clicked */
$(document).on('click', '[data-coll-category-filter-item]', function () {
  setTimeout(updateClearButtonState, 50);
});

/* Update when Boost/filters apply button is clicked */
$(document).on('click', '[data-collection-filters] [data-collection-filters-apply-btn]', function () {
  setTimeout(updateClearButtonState, 50);
});

/* Observe class changes on .collection-section-main (to catch .filterApplied toggles) */
(function observeSectionMain() {
  const sectionMain = document.querySelector('.collection-section-main');
  if (!sectionMain) return;

  const mo = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        updateClearButtonState();
      }
    }
  });

  mo.observe(sectionMain, { attributes: true, attributeFilter: ['class'] });
})();

/* Observe DOM for addition/removal of filter buttons (in case filters are injected dynamically) */
(function observeFilterList() {
  const container = document.querySelector('.filter-category-list') || document.body;

  const mo = new MutationObserver(mutations => {
    let changed = false;
    for (const m of mutations) {
      if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
        changed = true;
        break;
      }
      if (m.type === 'attributes' && m.target && m.target.classList && m.target.classList.contains('filter-category-btn')) {
        changed = true;
      }
    }
    if (changed) {
      // small debounce to allow any other handlers to run
      setTimeout(updateClearButtonState, 50);
    }
  });

  mo.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* Optional: expose for manual triggering */
window.updateClearButtonState = updateClearButtonState;

// custom clear filter button class


// data-sort-item
$(document).on("click","[data-sort-item]",function(e){
  e.preventDefault();
  window.scrollTo(0,2);
  console.log("sort btn clicked",$(this));
  $(this).addClass("is-selected").siblings().removeClass("is-selected");

  var sortVal = document.querySelector(`[data-sort-list] [data-sort-item].is-selected`) ? document.querySelector(`[data-sort-list] [data-sort-item].is-selected`).dataset.value : 'created-descending';
  // var sortVal = document.querySelector(`[data-sort-list] [data-sort-item].is-selected`) ? document.querySelector(`[data-sort-list] [data-sort-item].is-selected`).dataset.value : 'manual';
  console.log("sortVal-->",sortVal);
  
  if(location.search == ''){
    // if(sortVal == "manual"){
    //   window.history.replaceState({},document.title,`${location.origin}${location.pathname}`);
    // }else{
    //   window.history.replaceState({},document.title,`${location.origin}${location.pathname}?sort=${sortVal}`);
    // }
    window.history.replaceState({},document.title,`${location.origin}${location.pathname}?sort=${sortVal}`);
  }else{
    // if(sortVal == "manual"){
    if(sortVal == "created-descending"){
      let paramsString = "";
      let c = 0;
      const searchParams1 = new URLSearchParams(location.search);
      let pVal;
      for (const p of searchParams1) {
        // console.log(p);
        // if(p[0] != "sort" && p[0] != "page"){
        pVal = p[1];
        if(p[0] == "sort"){
          pVal = sortVal;
        }
        if(p[0] != "page"){
          if(c == 0){
            paramsString += `?${p[0]}=${pVal}`;
            c++;
          }else{
            paramsString += `&${p[0]}=${pVal}`;
          }
        }
      }
      window.history.replaceState({},document.title,`${location.origin}${location.pathname}${paramsString}`);
    }else{
      if(getUrlParameterBOOST("sort") != false){
        // let params = location.search;
        // const searchParams = new URLSearchParams(location.search);
        // for (const p of searchParams) {
        //   // console.log(p);
        //   if(p[0] == "sort"){
        //     params = params.replace(`${p[1]}`,`${sortVal}`);
        //   }
        // }
        let paramsString = "";
        let c = 0;
        const searchParams1 = new URLSearchParams(location.search);
        let pVal;
        for (const p of searchParams1) {
          // console.log(p);
          pVal = p[1];
          if(p[0] == "sort"){
            pVal = sortVal;
          }
          if(p[0] != "page"){
            if(c == 0){
              paramsString += `?${p[0]}=${pVal}`;
              c++;
            }else{
              paramsString += `&${p[0]}=${pVal}`;
            }
          }
        }
        // console.log("params",paramsString);
        window.history.replaceState({},document.title,`${location.origin}${location.pathname}${paramsString}`);
      }else{

        let paramsString = "?";
        let c = 0;
        const searchParams1 = new URLSearchParams(location.search);
        let pVal;
        for (const p of searchParams1) {
          // console.log(p);
          pVal = p[1];
          if(p[0] != "page"){
            if(c == 0){
              paramsString += `${p[0]}=${pVal}`;
              c++;
            }else{
              paramsString += `&${p[0]}=${pVal}`;
            }
          }
        }
        if(paramsString == "?"){
          paramsString += `sort=${sortVal}`;
        }else{
          paramsString += `&sort=${sortVal}`;
        }
        // console.log("params",paramsString);
        // window.history.replaceState({},document.title,`${location.origin}${location.pathname}${location.search}&sort=${sortVal}`);
        window.history.replaceState({},document.title,`${location.origin}${location.pathname}${paramsString}`);
      }
    }
  }

  currentPage = 1;
  seoHiddenProducts = 0;
  // console.log("sortVal",sortVal);
  window.scrollTo(0,2);
  document.body.classList.remove("open-collection-category");
  initCollpageCUSTOM(false,true);
});

// search input
$(document).on("keyup","[data-filter-search-input]",function(e){
  e.preventDefault();
  console.log("search input keyuppppp");
  var thisVal = $(this).val().toLowerCase();
  if($(this).val() != ""){
  $(this).closest(".filter-category_filter").find(".filter-category_filter-item").each(function(index,item){
    // console.log("item",item);
    if($(item).attr("data-value").includes(thisVal)){
      $(item).removeClass("hide");
    }else{
      $(item).addClass("hide");
    }
  });
  }else{
    $(this).closest(".filter-category_filter").find(".filter-category_filter-item").each(function(index,item){
      // console.log("item",item);
      $(item).removeClass("hide");
    });    
  }
});

// view details click event
$(document).on("click",".pro-quickview-view-details",function(e){
  e.preventDefault();
  console.log("view details clicked");
  document.querySelector(`.Grid__Cell a.ProductItem__ImageWrapper[data-product-id="${$(this).attr("data-product-id")}"]`)?.click();
});

$(document).on("click","#scrollTop",function(e){
  e.preventDefault();
  currentPage = 1;
  seoHiddenProducts = 0;
  let paramsString = "";
  let c = 0;
  const searchParams1 = new URLSearchParams(location.search);
  let pVal;
  for (const p of searchParams1) {
    // console.log(p);
    pVal = p[1];
    if(p[0] != "page"){
      if(c == 0){
        paramsString += `?${p[0]}=${pVal}`;
        c++;
      }else{
        paramsString += `&${p[0]}=${pVal}`;
      }
    }
  }
  // console.log("params",paramsString);
  window.history.replaceState({},document.title,`${location.origin}${location.pathname}${paramsString}`);
  document.querySelector(".boost-pfs-filter-products").innerHTML = "";
  window.scroll(0,2);
  initCollpageCUSTOM();
  console.log("scroll top click");
  
  setTimeout(() => {
    $('.CollectionInner__Products .Grid__Cell .swiper-wrapper0.flickity-enabled').flickity('destroy');
    $('.CollectionInner__Products .Grid__Cell .swiper-wrapper0 .swiper-slide0:not(:first-child)').remove();
  },200);
});

// swym-button swym-add-to-wishlist-view-product
$(document).on("click",".ProductItem__Wrapper .swym-add-to-wishlist-view-product.swym-added",function(e){
  console.log("swym unwishlist clicked");
  $(this).removeClass("swym-added swym-adding");
});
/*
=================================================
Coll page ======> end
=================================================
*/

// close sort popup when click outside in document
$(document).click(function(e){
  // console.log("ee",e);
  if(e.target != document.querySelector("[data-sort-button]") && e.target != document.querySelector(".coll_dr.collection-category") && !e.target.closest(".coll_dr.collection-category")){
    document.body.classList.remove("open-collection-category");
  }
  // console.log("closest>>>>>",e,!e.target.closest(".filter-dropdowns-item-single"));
  if(!e.target.closest("[data-filter-dropdowns-item]") && !e.target.closest(".filter-dropdowns-item-single") && e.target != document.querySelector("[data-collection-filters-apply-btn]")){
    // console.log("inside for closed");
    $("[data-filter-dropdowns-item]").removeClass("active");
  }
});


// sale template new development
$(document).on("click","[data-filter-dropdowns-item-title]",function(e){
  console.log("dropdown title clicked");
  e.preventDefault();
  $(this).parent("[data-filter-dropdowns-item]").siblings().removeClass("active");
  $(this).parent("[data-filter-dropdowns-item]").toggleClass("active");
});
//document.querySelector(`.filter-category_filter-item[data-value="shirt"] input`).checked = false
$(document).on("click","[data-filter-dropdowns-item] .filter-dropdowns-item-single",function(e){
  console.log("filter dropdown item clicked");
  e.preventDefault();
  this.classList.toggle("active");
  // $(this).parents("[data-filter-dropdowns-item]").removeClass("active");
  if(this.classList.contains("active")){
    if(document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`)) document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`).checked = true;
  }else{
    if(document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`)) document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`).checked = false;
  }
  // document.querySelector("[data-collection-filters-apply-btn]").click();
});

// custommisable + ready to show click event
// data-coll-category-filter-item
// $(document).on("click","[data-coll-category-filter-item]",function(e){
//   console.log("custom left filter item clicked");
//   e.preventDefault();
//   this.classList.toggle("active");
  
//   if(this.classList.contains("active")){
//     if(document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`)) document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`).checked = true;
//   }else{
//     if(document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`)) document.querySelector(`.filter-category_filter-item[data-value="${this.dataset.value}"] input`).checked = false;
//   }
//   document.querySelector("[data-collection-filters-apply-btn]").click();
// });

// custommisable + ready to show click event
$(document).on("click", "[data-coll-category-filter-item]", function (e) {
    e.preventDefault();

    const clicked = this;
    const isActive = clicked.classList.contains("active");

    // -----------------------------
    // Remove all active first
    // -----------------------------
    document.querySelectorAll("[data-coll-category-filter-item].active").forEach(item => {
        item.classList.remove("active");
        const rightInput = document.querySelector(
            `.filter-category_filter-item[data-value="${item.dataset.value}"] input`
        );
        if (rightInput) rightInput.checked = false;
    });

    // -----------------------------
    // Toggle active state
    // -----------------------------
    if (!isActive) {
        clicked.classList.add("active");

        const rightInput = document.querySelector(
            `.filter-category_filter-item[data-value="${clicked.dataset.value}"] input`
        );
        if (rightInput) rightInput.checked = true;
    }

    // -------------------------------------------------------------
    // Build PARAM URL (added: Customisable = 3 filter values)
    // -------------------------------------------------------------
    let paramUrl = `?`;
    let activeItem = document.querySelector("[data-coll-category-filter-item].active");

    if (activeItem) {
        const selectedVal = activeItem.dataset.filter;  // e.g. "Customisable" or "ready-to-wear"

        // Base key
        const key = `${activeItem.dataset.id}`;

        if (selectedVal === "Customisable") {
            // Add 3 product types
            const list = ["Customisable", "Semi-Stitched", "Hemming"];

            paramUrl += list
              .map(v => `${key}=${v.replaceAll(" ", "+")}`)
              .join("&");

        } else {
            // Normal single filter
            const val = selectedVal.replaceAll(" ", "+");
            paramUrl += `${key}=${val}`;
        }
    } else {
        // no filter selected
        paramUrl = `${location.origin}${location.pathname}`;
    }

    // console.log("paramUrl:", paramUrl);

    // Apply to browser URL
    window.history.replaceState({}, document.title, paramUrl);

    // Reload collection
    currentPage = 1;
    window.scrollTo(0, 0);
    initCollpageCUSTOM(false, true);
});




// .filter-category_filter-title .icon
$(document).on("click","[data-filter-dropdowns-apply-btn]",function(e){
  e.preventDefault();
  document.querySelector("[data-collection-filters-apply-btn]").click();
  $(".coll-category-filter [data-filter-dropdowns-item]").removeClass("active");
});

// .filter-category_filter-title .icon
$(document).on("click",".filter-category_filter-title .icon, .cat-filter-overlay-mb",function(e){
  e.preventDefault();
  $(".coll-category-filter [data-filter-dropdowns-item]").removeClass("active");
});